import SaudiVisionLogo from '../assests/Saudi_Vision_2030_logo.svg.png';

export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'HOME',
      about: 'WHO WE ARE',
      service: 'PRODUCT',
      career: 'CAREER',
      contact: 'CONTACT'
    },
    // Home Page
    home: {
      hero: {
        bgImage: '/uploads/industry.png',
        visionLogo: SaudiVisionLogo,
        badge: 'Premier Industrial Sourcing KSA',
        titleLine1: 'Supplying the',
        titleEmphasis: 'Future',
        titleLine2: 'of Industry',
        subtitle: 'Strategic industrial building materials trading, bridging global quality with Saudi Arabia\'s infrastructure ambitions.',
        explore: 'Explore Solutions',
        requestQuote: 'Request a Quote'
      },
      badges: {
        delivery: 'KSA-Wide Delivery',
        certified: 'Certified Brands',
        iso: 'ISO 9001 Compliant',
        support: '24/7 Technical Support'
      },
      about: {
        image: '/uploads/workers.webp',
        label: 'Established Authority',
        title: 'Expertise That Shapes Nations.',
        description: 'AMHBM (Amal Mohammed Harthi for Building Materials) stands as a cornerstone of Saudi Arabia’s industrial sector. More than a trader, we are a strategic partner providing the backbone for massive infrastructure projects, industrial complexes, and civil engineering feats.',
        vision: {
          title: 'Our Vision',
          text: 'To be the most trusted industrial sourcing powerhouse in the GCC, fueling the next decade of infrastructure.'
        },
        mission: {
          title: 'Our Mission',
          text: 'Delivering uncompromised engineering precision and world-class materials to every corner of the Kingdom.'
        },
        legacyYears: '100+',
        legacyText: 'Clients'
      },
      solutions: {
        label: 'Our Solutions',
        title: 'High-Impact Engineering Categories',
        description: 'Curated selection of industrial grade materials sourced from leading global manufacturers, tailored for the harsh environments of the Middle East.',
        categories: {
          pipes: {
            image: '/uploads/1770008129-CS_pipes.webp',
            badge: 'Premium Sourcing',
            title: 'Pipes & Tubing',
            desc: 'Specialized alloy and high-grade steel solutions for fluid systems.'
          },
          valves: {
            image: '/uploads/1770009030-GateValves.webp',
            badge: 'Precision Control',
            title: 'Valves',
            desc: 'Automation and manual control for critical flow management.'
          },
          electrical: {
            image: '/uploads/1770013452-IndustrialElectrical.webp',
            badge: 'Power Solutions',
            title: 'Electrical Infrastructure',
            desc: 'Robust wiring and containment systems for industrial plants.'
          }
        },
        services: {
          title: 'Value-Added Services',
          procurement: {
            title: 'Strategic Procurement',
            text: 'Leveraging deep networks to find hard-to-source technical components globally.'
          },
          logistics: {
            title: 'Logistics & Warehousing',
            text: 'Integrated supply chain with localized inventory for rapid site deployment.'
          },
          industries: {
            oil: 'Oil & Gas',
            industry: 'Industry',
            energy: 'Energy',
            civil: 'Civil Infra'
          }
        }
      },
      commitment: {
        image: '/uploads/statigic partner.png',
        label: 'Our Commitment',
        title: 'Uncompromising Standard Compliance.',
        description: 'Quality is not just a checkbox at AMHBM; it is our foundation. We strictly adhere to international benchmarks, ensuring that every bolt, pipe, and valve meets the rigorous demands of Saudi Arabia\'s industrial giants.',
        standards: {
          asme: 'Certified',
          astm: 'Standard',
          iso: 'Compliant',
          din: 'Approved'
        }
      },
      vision2030: {
        logo: SaudiVisionLogo,
        title: 'Paving the Way for Saudi Vision 2030',
        text: 'As a proud Saudi enterprise, we are catalysts for change. By localizing expertise and providing the critical components for National Transformation projects, AMHBM is directly contributing to a sustainable, diversified industrial future.',
        partner: 'Strategic Partner',
        link: 'Learn about our impact'
      },
      contact: {
        titleLine1: 'Secure Your Industrial',
        titleEmphasis: 'Supply Chain Today.',
        subtitle: 'Partner with industry experts who understand the nuances of the KSA market. Let\'s discuss your project specifications.',
        cta1: 'Request Detailed Quote',
        cta2: 'Consult an Expert'
      }
    },
    // Service Page (Products & Categories)
    servicePage: {
      hero: {
        badge: 'Our Catalog',
        titleLine1: 'Comprehensive',
        titleEmphasis: 'Industrial Solutions',
        subtitle:
          'Supplying a wide range of mechanical, electrical, and piping materials across the Kingdom with uncompromising quality standards.',
        bgImage: ''
      },
      catalogNav: {
        title: 'Product Catalog',
        catalogPdf: '/uploads/AMHBM_Profile.pdf',
        items: {
          pipes: 'Pipes',
          fittings: 'Fittings',
          flanges: 'Flanges',
          valves: 'Valves',
          fire: 'Fire Hydrant & Grooved Fittings',
          instrumentation: 'Instrumentation Accessories',
          fasteners: 'Fasteners & Stud',
          gaskets: 'Gasket & Insulation Kits',
          electrical: 'Industrial Electrical',
          telecom: 'Industrial Telecom',
          sanitary: 'Sanitary',
          chemicals: 'Solvents & Chemicals'
        }
      },
      overview: {
        title: 'Industrial Catalog Overview',
        description:
          'Explore our comprehensive range of high-performance industrial materials, engineered to meet the stringent standards of KSA infrastructure.'
      },
      sidebar: {
        title: 'Refine Search',
        materialType: {
          title: 'Material Type',
          options: ['Carbon Steel', 'Stainless Steel', 'Alloy Steel', 'Duplex & Super Duplex']
        },
        standards: {
          title: 'Industrial Standards',
          options: ['ASME / ANSI', 'ASTM Standards', 'API Specifications', 'DIN / EN']
        },
        help: {
          text: 'Need a specific specification not listed? Contact our procurement team.',
          link: 'Send Technical Inquiry'
        }
      },
      categories: {
        pipes: {
          title: 'Pipes & Piping',
          image: '/uploads/1770008129-CS_pipes.webp',
          description: 'A complete inventory of carbon steel, stainless steel, and ductile iron piping. Designed for high-temperature and high-pressure applications in oil, gas, and water infrastructure.',
          items: [
            {
              name: 'CS PIPES',
              type: 'detailed',
              images: [
                '/uploads/1770008129-CS_pipes.webp'
              ],
              specs: {
                standard: 'ASME, ASTM, BS and DIN',
                material: [
                  'Carbon Steel & Alloy Pipes(Seamless)',
                  'Carbon Steel ERW(Welded Type)',
                  'Carbon Steel (Submerged Arc Welded)'
                ],
                sizes: 'From ½" to 80"',
                schedule: '20/30/40/60/80/120/XXS/STD and XS',
                grade: [
                  'A53 Gr.B, A106 Gr.B, APL5L Gr.B X42, X52 & A333-6',
                  'A53-A, A53-b and APL 5L Gr.B',
                  'API 5L Gr.B, X52 and X60'
                ],
                length: '6, 12Mtr, DRL, SRL7'
              },
              footerNote: 'We Provide Special Sizes and Grades on request'
            },
            {
              name: 'SS PIPES',
              type: 'detailed',
              images: [
                '/uploads/1770008139-SS_pipes.webp'
              ],
              specs: {
                standard: 'ASME, ASTM, BS and DIN',
                material: [
                  'Stainless Steel(Seamless), Stainless Steel Welded(ERW/EFW)'
                ],
                sizes: '1/8" to 12"',
                schedule: '10/20/40/80/120/XXS//SX/STD',
                grade: [
                  'A312-304/304L, 316/316L',
                  'A312-304/304L, 316/326L A358'
                ],
                length: '6, 12Mtr, DRL, SRL7'
              },
              footerNote: 'We Provide Special Sizes and Grades on request'
            },
            {
              name: 'PVC PIPES',
              type: 'detailed',
              images: [
                '/uploads/1770008202-PVC_Pipes1.webp'
              ],
              specs: {
                material: 'PVC',
                thickness: 'Standard SCH 40 / SCH 80',
                color: 'Gray',
                sizes: '½" to 12"'
              }
            },
            {
              name: 'UPVC',
              type: 'detailed',
              images: [
                '/uploads/1770008219-upvc-pipe.webp'
              ],
              specs: {
                material: 'UPVC',
                standards: 'ASTM D1785',
                sizes: '½" to 12"'
              }
            },
            {
              name: 'CPVC',
              type: 'detailed',
              images: [
                '/uploads/1770008238-cpvc-pipes.webp'
              ],
              specs: {
                material: 'CPVC',
                thickness: 'SCH 80',
                application: 'Hot & Cold Water'
              }
            },
            {
              name: 'HDPE',
              type: 'detailed',
              images: [
                '/uploads/1770008253-HDPE_Pipes.webp'
              ],
              specs: {
                material: 'High Density Polyethylene (HDPE)',
                rating: 'PN10, PN16, PN20, PN25',
                sizes: '20mm to 1200mm'
              }
            },
            {
              name: 'PPR PIPES',
              type: 'detailed',
              images: [
                '/uploads/1770008370-PPR_pipes.jpg'
              ],
              specs: {
                standard: 'DIN 8077/8078',
                brands: ['NIBCO', 'GULF PLAS', 'REDI', 'FIP', 'IPEX', 'NEPROPLAST']
              }
            },
            {
              name: 'GI PIPES',
              type: 'detailed',
              images: [
                '/uploads/1770008384-GI-PIPES.webp'
              ],
              specs: {
                material: 'Galvanized Iron',
                standard: 'BS 1387 Class A, B, C',
                sizes: '½" to 6"'
              }
            }
          ]
        },
        fittings: {
          title: 'Industrial Fittings',
          image: '/uploads/1770008921-FittingsBackgroundimage.webp',
          description: 'High-grade industrial fittings for seamless piping connections. Available in various materials and specifications to meet rigorous project requirements.',
          items: [
            {
              name: 'CS BUTTWELD FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008409-CS_BUttweld_Fittings.webp'
              ],
              specs: {
                types: ['Elbows (45°/90°)', 'Tees', 'Reducers', 'Caps', 'Couplings'],
                material: ['Carbon Steel (WPB)', 'WPL6'],
                standards: ['ASME B16.9', 'MSS SP-75']
              }
            },
            {
              name: 'SS BUTT WELD FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008419-SSBUTTWELDFITTINGS.webp'
              ],
              specs: {
                types: ['Elbows', 'Tees', 'Reducers', 'Caps', 'Stub Ends'],
                material: ['Stainless Steel (304/304L, 316/316L)'],
                standards: ['ASME B16.9', 'ASTM A403']
              }
            },
            {
              name: 'FORGED CS FITTING',
              type: 'detailed',
              images: [
                '/uploads/1770008442-Carbon-Steel-Forged-Fittings.webp'
              ],
              specs: {
                types: ['Socket Weld', 'Threaded (NPT, BSP)'],
                material: ['Carbon Steel (A105, A350 LF2)'],
                standards: ['ASME B16.11', 'BS 3799']
              }
            },
            {
              name: 'FORGED SS FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008455-FOREGED SS FITTINGS.webp'
              ],
              specs: {
                types: ['Socket Weld', 'Threaded'],
                material: ['Stainless Steel (F304/L, F316/L)'],
                standards: ['ASME B16.11']
              }
            },
            {
              name: 'FORGED MALLEABLE IRON FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008465-FORGED MALLEABLE IRON FITTINGS.webp'
              ],
              specs: {
                types: ['Elbows', 'Tees', 'Crosses', 'Unions'],
                material: ['Malleable Iron'],
                standards: ['ASME B16.3', 'BS EN 10242']
              }
            },
            {
              name: 'PVC/CPVC/UPVC FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008497-PVCFITTINGS.jpg'
              ],
              specs: {
                types: ['Socket', 'Threaded', 'Flanged'],
                material: ['PVC', 'CPVC', 'UPVC'],
                standards: ['ASTM D2466', 'ASTM D2467', 'ASTM F439']
              }
            },
            {
              name: 'HDPE FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008512-HDPE_Fittings.webp'
              ],
              specs: {
                types: ['Butt Fusion', 'Electrofusion', 'Compression'],
                material: ['HDPE (PE100, PE80)'],
                standards: ['ISO 4427', 'EN 12201']
              }
            },
            {
              name: 'PPR FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008526-PPR_FITTINGS.jpg'
              ],
              specs: {
                types: ['Socket Fusion', 'Threaded Transition'],
                material: ['PPRC'],
                standards: ['DIN 8077/8078']
              }
            },
            {
              name: 'GI FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770008541-GI_FITTINGS.jpg'
              ],
              specs: {
                types: ['Elbows', 'Tees', 'Nipples', 'Unions'],
                material: ['Galvanized Iron'],
                standards: ['BS 1387', 'BS EN 10255']
              }
            }
          ]
        },
        flanges: {
          title: 'Flanges',
          image: '/uploads/1770008936-FlangesBgImage.jpg',
          description: 'Premium quality flanges ensuring leak-proof connections for high-pressure industrial applications.',
          items: [
            {
              name: 'CS FLANGES',
              type: 'detailed',
              images: [
                '/uploads/1770008955-CS_Flanges.webp'
              ],
              specs: {
                types: ['Weld Neck', 'Slip-On', 'Blind', 'Socket Weld', 'Threaded'],
                rating: ['150#', '300#', '600#', '900#', '1500#', '2500#'],
                facing: ['RF (Raised Face)', 'RTJ (Ring Type Joint)', 'FF (Flat Face)'],
                material: ['Carbon Steel']
              }
            },
            {
              name: 'SS FLANGES',
              type: 'detailed',
              images: [
                '/uploads/1770008968-SS_Flanges.webp'
              ],
              specs: {
                types: ['Weld Neck', 'Slip-On', 'Blind', 'Socket Weld', 'Threaded'],
                rating: ['150#', '300#', '600#', '900#', '1500#', '2500#'],
                facing: ['RF (Raised Face)', 'RTJ (Ring Type Joint)', 'FF (Flat Face)'],
                material: ['Stainless Steel (304/304L, 316/316L)']
              }
            },
            {
              name: 'MS FLANGES',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                types: ['Plate Flanges', 'Table D/E/F'],
                rating: ['PN6', 'PN10', 'PN16', 'PN25', 'PN40'],
                facing: ['RF', 'FF'],
                material: ['Mild Steel']
              }
            },
            {
              name: 'GI FLANGES',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                types: ['Threaded', 'Slip-On'],
                rating: ['150#', '300#', 'PN16'],
                facing: ['RF', 'FF'],
                material: ['Galvanized Iron']
              }
            },
            {
              name: 'PVC/CPVC/UPVC FLANGES',
              type: 'detailed',
              images: [
                '/uploads/1770008982-PVC_CPVC_UPVC_Flanges.webp'
              ],
              specs: {
                types: ['Van Stone', 'Blind', 'One-Piece'],
                rating: ['SCH 80', 'PN10', 'PN16'],
                facing: ['FF'],
                material: ['PVC', 'CPVC', 'UPVC']
              }
            },
            {
              name: 'HDPE FLANGES',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                types: ['Stub End', 'Backing Ring'],
                rating: ['SDR 11', 'SDR 17', 'PN10', 'PN16'],
                facing: ['FF'],
                material: ['HDPE (PE100)']
              }
            }
          ]
        },
        valves: {
          title: 'Industrial Valves',
          image: '/uploads/1770009030-GateValves.webp',
          description: 'High-integrity flow control solutions including Gate, Globe, Ball, and Check valves. Available in forged and cast steel with manual or automated actuation systems.',
          items: [
            {
              name: 'GATE VALVES',
              type: 'detailed',
              images: [
                '/uploads/1770009030-GateValves.webp'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPVC/CPVC/HDPE/PPR']
              }
            },
            {
              name: 'BALL VALVES',
              type: 'detailed',
              images: [
                '/uploads/1770009042-BallValve.webp'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'CHECK VALVE',
              type: 'detailed',
              images: [
                '/uploads/1770009326-Check-Valve.webp'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'BUTTERFLY VALVE',
              type: 'detailed',
              images: [
                '/uploads/1770009336-Butterfly_valve.webp'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'SAFETY VALVE',
              type: 'detailed',
              images: [
                '/uploads/1770009350-Safety_Valves.jpg'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'NEEDLE VALVE',
              type: 'detailed',
              images: [
                '/uploads/1770009360-Needle_Valves.jpg'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'PRESSURE REDUCING VALVES',
              type: 'detailed',
              images: [
                '/uploads/1770009371-pressure-regulating-valves.webp'
              ],
              specs: {
                materials: ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS']
              }
            },
            {
              name: 'DIAPHRAGM VALVE',
              type: 'detailed',
              images: [
                '/uploads/1770009388-Diaphragm-Valve.webp'
              ],
              specs: {
                materials: ['PVC/UPVC/CPVC/HDPE']
              }
            }
          ]
        },
        fire: {
          title: 'Fire Fighting',
          image: '/uploads/1770009990-FireFightings.jpg',
          description: 'Comprehensive safety solutions including hydrants, sprinkler systems, and fire detection panels. Fully compliant with Civil Defense standards and NFPA regulations.',
          items: [
            {
              name: 'SPRINKLER SYSTEMS',
              type: 'detailed',
              images: [
                '/uploads/1770009840-Sprinkler_Systems.jpg'
              ],
              specs: {
                types: ['Pendent', 'Upright', 'Sidewall', 'Concealed'],
                response: ['Standard Response', 'Quick Response'],
                finish: ['Brass', 'Chrome', 'White Polyester'],
                approvals: ['UL Listed', 'FM Approved', 'Civil Defense Approved']
              }
            },
            {
              name: 'VALVES & HYDRANTS',
              type: 'detailed',
              images: [
                '/uploads/1770009990-FireFightings.jpg'
              ],
              specs: {
                items: ['OS&Y Gate Valves', 'Check Valves', 'Wet Barrel Hydrants', 'Dry Barrel Hydrants'],
                pressure: 'Rated up to 300 PSI',
                connection: 'Flanged / Grooved / Threaded',
                standard: 'NFPA, UL/FM'
              }
            },
            {
              name: 'GROOVED FITTINGS',
              type: 'detailed',
              images: [
                '/uploads/1770009919-GroovedFittings.jpg'
              ],
              specs: {
                material: 'Ductile Iron ASTM A536',
                items: ['Couplings', 'Elbows', 'Tees', 'Reducers', 'Caps'],
                sizes: '1" to 12"',
                finish: 'Painted Red / Galvanized'
              }
            }
          ]
        },
        fasteners: {
          title: 'Fasteners & Stud',
          image: '/uploads/1770012306-STUDBgImage.webp',
          description: 'High-strength industrial fasteners and studs designed for critical structural and piping connections.',
          items: [
            {
              name: 'FASTENERS & STUDS',
              type: 'detailed',
              images: [
                '/uploads/1770012319-stud-bolts.jpg'
              ],
              specs: {
                materials: ['CS', 'SS', 'ALLOY', 'ALUMIINUM', 'BRASS', 'BRONZE', 'POLYMERS/PLASTIC', 'COATED']
              }
            }
          ]
        },
        gaskets: {
          title: 'Gasket & Insulation Kits',
          image: '/uploads/1770012581-GasketsBgImage.jpg',
          description: 'Comprehensive sealing solutions including gaskets and isolation kits for flange protection and leak prevention.',
          items: [
            {
              name: 'GASKET AND INSULATION KITS',
              type: 'detailed',
              images: [
                '/uploads/1770012602-Gaskets&InsulationKIts.webp'
              ],
              specs: {
                types: ['RING JOINT', 'SPIRAL WOULD', 'FLAT CUT', 'FLEXIBLE GRAPHITE', 'STEEL RE-INFORCED RUBBER', 'METAL JACKET', 'SERRATED METAL', 'NON ASBESTTOS RUBBER']
              }
            }
          ]
        },
        sanitary: {
          title: 'Sanitary',
          image: '/uploads/1770014085-Sanitary.jpg',
          description: 'Hygienic and durable sanitary systems including drainage and plumbing solutions for commercial and industrial facilities.',
          items: [
            {
              name: 'SANITARY WARE',
              type: 'detailed',
              images: [
                '/uploads/1770014117-SanitaryWare.webp'
              ],
              specs: {
                items: ['MIXER', 'FAUCET', 'WASH BASINS FLUSH TANK', 'CLOSETS', 'BATHROOM ACCESSORIES']
              }
            },
            {
              name: 'DRAINS',
              type: 'detailed',
              images: [
                '/uploads/1770014129-drains.webp'
              ],
              specs: {
                types: ['FLOOR & AREA DRAIN', 'ROOF DRAIN', 'HYDRO-FLO TRNCH DRAIN', 'SANITARY FLOOR SINK', 'GULLIES', 'GRATINGS']
              }
            }
          ]
        },
        chemicals: {
          title: 'Solvents & Chemicals',
          image: '/uploads/1770014336-Solvent&Chemicals.webp',
          description: 'Specialized cements, coatings, and chemical solutions to protect, bond, and refurbish critical infrastructure and flooring systems.',
          items: [
            {
              name: 'PVC CEMENT',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Professional grade PVC cement for secure pipe bonding.'
            },
            {
              name: 'CPVC CEMENT',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'High-temperature CPVC cement for industrial piping systems.'
            },
            {
              name: 'UPVC CEMENT',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Heavy duty UPVC cement for pressure and drainage applications.'
            },
            {
              name: 'REFURBISHMENT SOLUTION',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Advanced solutions for restoring and extending the life of infrastructure.'
            },
            {
              name: 'FLOORING SOLUTION',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Durable epoxy and polyurethane flooring systems for industrial use.'
            },
            {
              name: 'CONCRETE SOLUTION',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Admixtures and repair mortars for strengthening concrete structures.'
            },
            {
              name: 'WATERPROOFING SOLUTION',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Comprehensive waterproofing membranes and coatings for all surfaces.'
            },
            {
              name: 'SEALING & BONDING SOLUTION',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'High-performance sealants and adhesives for construction joints.'
            },
            {
              name: 'ROOFING SOLUTIONS',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'Advanced roofing systems for thermal protection and leak prevention.'
            }
          ]
        },
        tools: {
          title: 'Tools for Construction & Industry',
          image: '/uploads/workers.webp',
          description: 'Professional-grade hand tools, power tools, and industrial specialty tools engineered for demanding construction and maintenance environments.',
          items: [
            {
              name: 'HAND TOOLS',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                categories: ['Measuring & Layout', 'Cutting Tools', 'Fastening Tools', 'Striking Tools'],
                items: ['Calipers', 'Wrenches', 'Hammers', 'Screwdrivers', 'Pliers'],
                quality: 'Chrome Vanadium Steel, Drop Forged'
              }
            },
            {
              name: 'POWER TOOLS',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['Drills & Drivers', 'Grinders & Saws', 'Rotary Hammers', 'Demolition Breakers'],
                power: ['Cordless 18V/40V', 'Corded 110V/220V'],
                brands: ['Major Industrial Brands Supported']
              }
            },
            {
              name: 'INDUSTRIAL SPECIALTY',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['Pneumatic Impact Wrenches', 'Pipe Threading Machines', 'Hydraulic Crimpers', 'Cable Cutters'],
                application: ['Heavy Industry', 'Pipe Fitting', 'Electrical Installation']
              }
            }
          ]
        },
        instrumentation: {
          title: 'Instrumentation',
          image: '/uploads/1770011999-InstrumentationAccessoriesBgImage.jpg',
          description: 'Precision accessories and fittings that ensure reliable measurement, control, and connectivity in critical instrumentation loops.',
          items: [
            {
              name: 'PRESSURE GAUGES',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                types: ['Bourdon Tube', 'Diaphragm Seal', 'Differential Pressure'],
                dialSize: ['63mm', '100mm', '150mm'],
                material: ['Stainless Steel 316L', 'Brass', 'Monel'],
                accuracy: ['±1.0%', '±1.6%', '±0.5%']
              }
            },
            {
              name: 'TUBING & TUBE FITTINGS',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                types: ['Compression Fittings', 'Face Seal Fittings', 'Seamless Tubing'],
                material: ['SS316/316L', 'Duplex', 'Inconel', 'Hastelloy'],
                pressure: ['Up to 6000 PSI', 'Up to 10000 PSI'],
                standards: ['ASTM A269', 'ASTM A213']
              }
            },
            {
              name: 'NEEDLE & MANIFOLD VALVES',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                types: ['2-Way', '3-Way', '5-Way Manifolds', 'Integral Bonnet Needle Valves'],
                connection: ['NPT', 'BSP', 'Compression'],
                rating: ['6000 PSI', '10000 PSI'],
                packing: ['PTFE', 'Graphite']
              }
            }
          ]
        },
        electrical: {
          title: 'Industrial Electrical',
          image: '/uploads/1770013452-IndustrialElectrical.webp',
          description: 'Low, medium, and high-voltage cabling with complete termination, protection, and earthing accessories for safe power distribution.',
          items: [
            {
              name: 'CABLE',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                types: ['LV CABLE', 'MV', 'HV', 'FLEXIBLE CABLE']
              }
            },
            {
              name: 'CABLE LUGS',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                materials: ['COPPER', 'ALUMINIUM', 'BRONZE', 'BIMETALLIC']
              }
            },
            {
              name: 'CABLE TIES',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                types: ['PVC', 'SS', 'PVC COATED']
              }
            },
            {
              name: 'ELECTRICAL FITTINGS AND ACCESSORIES',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                items: [
                    'ELECTRICAL CONDUIT (EMT, RIGID, PVC/UPVC/CPVC)',
                    'EXPLOSION PROOF ENCLOUSERS',
                    'CIRCUIT BREAKERS',
                    'ELECTRICAL BOX',
                    'WIRE CONNECTORS',
                    'WIRE MARKERS',
                    'CABLE GLAND (PLASTIC/NYLON, BRASS, SS, ALUMINIUM)',
                    'HEAT SHRINK TUBES',
                    'TERMINATION AND JOINT KITS'
                ]
              }
            },
            {
              name: 'CABLE TRAY & LADDER',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                types: ['LADDER TYPE', 'PERFRATED TYPE', 'SOLID BOTTOM', 'WIRE MESH', 'CHANNEL']
              }
            }
          ]
        },
        telecom: {
          title: 'Industrial Telecom',
          image: '/uploads/telecom.png',
          description: 'Fibre optic and ducting solutions that enable robust industrial networking and communications infrastructure.',
          items: [
            {
              name: 'INDUSTRIAL TELECOM',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                items: [
                    'FIBRE OPTIC CABLES',
                    'DUCT PLUG,DUCT SEAL',
                    'UG CABLE MARKERS',
                    'CORRUGATED AND NON CORRUGATED PIPES',
                    'DEECTABLE & NON WARNING TAPES'
                ]
              }
            },
            {
              name: 'ELECTRICAL COATED CODUIT FITTING ACCESSORIES',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['PVC COATED CONDUIT & FITTINGS', 'EPOXY COATED CONDUIT & FITTINGS', 'POWDER COATED CONDUIT & FITTINGS']
              }
            },
            {
              name: 'EARTHING SUPPORT',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                items: ['EARTH RODS', 'EARTH PLATES', 'EARTH WIRE/STRIP/TAPES', 'CLAMP & CONNECTORS', 'EARTH PITS & CHAMBERS']
              }
            }
          ]
        },
        building: {
          title: 'Building Materials',
          image: '/uploads/workers.webp',
          description: 'Fundamental construction materials including wood, steel, insulation, and cement products for structural and architectural applications.',
          items: [
            {
              name: 'LUMBER & WOOD PRODUCTS',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['Softwood (Pine, Spruce)', 'Hardwood (Oak, Maple)', 'Plywood & OSB'],
                grades: ['Construction Grade', 'Furniture Grade', 'Marine Grade'],
                applications: ['Structural Framing', 'Formwork', 'Interior Finishing']
              }
            },
            {
              name: 'INSULATION MATERIALS',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['Fiberglass Batts', 'Rockwool Slabs', 'XPS/EPS Boards'],
                properties: ['Thermal Resistance (R-Value)', 'Acoustic Dampening', 'Fire Resistance'],
                forms: ['Rolls', 'Rigid Boards', 'Loose Fill']
              }
            },
            {
              name: 'STEEL PRODUCTS',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                structural: ['I-Beams (IPE, HEA, HEB)', 'Channels (UPN)', 'Angles'],
                reinforcement: ['Rebar (Deformed Bars)', 'Wire Mesh', 'Tying Wire'],
                standards: ['ASTM A36', 'BS 4449', 'DIN 488']
              }
            },
            {
              name: 'GYPSUM & ACCESSORIES',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                boards: ['Regular', 'Moisture Resistant (Green)', 'Fire Rated (Pink)'],
                profiles: ['Studs', 'Tracks', 'Furring Channels'],
                accessories: ['Joint Compound', 'Fiber Tape', 'Corner Beads']
              }
            },
            {
              name: 'CEMENT & AGGREGATES',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                cement: ['OPC (Type I)', 'SRC (Type V)', 'White Cement'],
                aggregates: ['Fine Sand', 'Coarse Sand', 'Crushed Stone (3/4", 3/8")'],
                additives: ['Plasticizers', 'Waterproofers', 'Bonding Agents']
              }
            }
          ]
        }
      },
      badges: {
        aramcoApproved: 'Aramco Approved',
        sabicReady: 'SABIC Ready',
        api6d: 'API 6D Certified',
        ulListed: 'UL Listed',
        fmApproved: 'FM Approved'
      },
      viewRange: 'View Full Range',
      cta: 'Explore More Categories'
    },
    // About Page
    aboutPage: {
      hero: {
        bgImage: '/uploads/industry.png',
        badge: 'Established Excellence',
        titleLine1: 'Who We',
        titleEmphasis: 'Are.',
        subtitle: 'AMHBM stands as a pillar of Saudi Arabia\'s industrial supply chain, providing the essential materials that build the future of the Kingdom.'
      },
      pillars: {
        integrity: {
          label: 'Our Pillar',
          title: 'Unwavering Integrity'
        },
        quality: {
          label: 'Our Standard',
          title: 'Engineering Quality'
        },
        commitment: {
          label: 'Our Promise',
          title: 'True Commitment'
        }
      },
      visionMission: {
        vision: {
          title: 'The Vision',
          text: 'To be the foremost strategic partner in the Middle East’s industrial evolution, recognized for setting the gold standard in procurement, technical expertise, and reliability. We envision a future where AMHBM is synonymous with the structural integrity of Saudi Arabia\'s most ambitious projects.'
        },
        mission: {
          title: 'The Mission',
          text: 'Our mission is to empower the Kingdom\'s industrial sectors by providing high-specification building materials through a seamless, globally-integrated supply chain. We are dedicated to ensuring safety, efficiency, and sustainability in every component we deliver to our partners.'
        }
      },
      quote: {
        image: '/uploads/workers.webp',
        imageOverlayTitle: 'Vision 2030',
        imageOverlaySubtitle: 'Kingdom of Saudi Arabia',
        text1: 'We are not just suppliers; we are the foundation of',
        textEmphasis: 'Saudi Vision 2030.',
        desc1: 'At AMHBM, we recognize that our role transcends simple trade. As Saudi Arabia undergoes a historic transformation, the materials we provide form the physical backbone of our nation\'s progress.',
        desc2: 'Our commitment to quality is personal. Every valve, every pipe, and every electrical component we source is scrutinized to ensure it meets the rigorous demands of the Kingdom\'s future infrastructure. Together, we are building a legacy of excellence.',
        role: 'CEO & Managing Director',
        company: 'Amal Mohammed Harthi for Building Materials'
      },
      advantage: {
        label: 'Strategic Advantage',
        title: 'Why Partners Choose AMHBM',
        global: {
          title: 'Global Partnerships',
          text: 'Direct access to Tier-1 manufacturers across Europe, Asia, and the Americas, ensuring authentic, high-performance materials.'
        },
        logistics: {
          title: 'Logistical Excellence',
          text: 'A robust distribution network across Saudi Arabia that guarantees on-time delivery even to the most remote project sites.'
        },
        technical: {
          title: 'Technical Expertise',
          text: 'Our team of specialists provides deep technical consultation to ensure materials perfectly match engineering specifications.'
        }
      },
      vision2030: {
        logo: SaudiVisionLogo,
        label: 'National Alignment',
        titleLine1: 'Committed to',
        titleEmphasis: 'Saudi Vision 2030',
        text: 'As Saudi Arabia builds for the future, AMHBM provides the critical industrial components that power the Kingdom\'s infrastructure. From giga-projects to industrial cities, our supply chain is the backbone of the nation\'s transformative growth and economic diversification goals.',
        link: 'Learn about our impact'
      }
    },
    // Career Page (Existing)
    careerPage: {
      hero: {
        image: '/uploads/industry.png',
        badge: 'CAREER OPPORTUNITIES',
        titleLine1: 'Build the Future of',
        titleEmphasis: 'Saudi Industry',
        titleLine2: 'with Us',
        subtitle:
          'Join a team of experts dedicated to excellence in industrial supply chain and infrastructure. Empowering the Kingdom\'s growth through innovation and integrity.',
        cta: 'Explore Openings'
      },
      culture: {
        badge: 'Life at AMHBM',
        title: 'Culture that Drives Progress.',
        description:
          'Our culture is built on innovation, integrity, and a deep alignment with Saudi Vision 2030. We foster an environment where professional growth meets national impact.',
        cards: {
          collaboration: {
            image: '/uploads/workers.webp',
            title: 'Team Collaboration',
            text: 'Fostering a spirit of shared success in every project.'
          },
          workshops: {
            image: '/uploads/statigic partner.png',
            title: 'Workshops',
            text: 'Continuous learning and professional skill enhancement.'
          },
          impact: {
            image: '/uploads/industry.png',
            title: 'Impact on Site',
            text: 'Witnessing the tangible results of our industrial supply.'
          },
          vision: {
            image: '/uploads/workers.webp',
            title: 'Vision 2030',
            text: 'Dedicated to the Kingdom\'s industrial transformation.'
          }
        }
      },
      benefits: {
        items: {
          compensation: {
            title: 'Competitive Compensation',
            text: 'Rewarding excellence with industry-leading packages and benefits.'
          },
          growth: {
            title: 'Professional Growth',
            text: 'Clear career pathways and support for advanced certifications.'
          },
          impact: {
            title: 'Saudi-focused Impact',
            text: 'Directly contribute to the Kingdom\'s infrastructure and giga-projects.'
          },
          culture: {
            title: 'Inclusive Culture',
            text: 'A diverse workplace where every voice is valued and heard.'
          }
        }
      },
      applicationForm: {
        firstName: 'First Name',
        firstNamePlaceholder: 'Enter your first name here',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Last Name',
        dateOfBirth: 'Date of Birth',
        dateOfBirthPlaceholder: 'MM-DD-YYY',
        phoneNumber: 'Phone Number',
        phoneNumberPlaceholder: 'Example: +966-5xxxxxxx',
        gender: 'Gender',
        genderOptions: {
          male: 'Male',
          female: 'Female',
          preferNotToSay: 'Prefer Not To Say'
        },
        email: 'Email Address',
        emailPlaceholder: 'Email',
        fileUpload: 'File Upload',
        fileUploadButton: 'Choose File',
        fileUploadPlaceholder: 'No file chosen'
      },

      cta: {
        title: 'Don\'t see a fit?',
        text: 'Send us your CV for future opportunities. We are always looking for exceptional talent to join our industrial mission.',
        button: 'Upload Resume'
      }
    },
    // Contact Page (Existing)
    contactPage: {
      hero: {
        image: '/uploads/industry.png',
        badge: 'Get In Touch',
        titleLine1: 'Contact Our',
        titleEmphasis: 'Industrial Experts',
        subtitle:
          'From material procurement to project support, we are here to assist your industrial mission in the Kingdom.'
      },
      cards: {
        visitTitle: 'Visit Us',
        visitLine1: 'Riyadh Headquarters',
        visitLine2: 'Al-Malaz District, King Abdulaziz Road',
        visitLine3: 'Riyadh, Kingdom of Saudi Arabia',
        callTitle: 'Call Us',
        callMainLabel: 'Main Office:',
        callSalesLabel: 'Sales Dept:',
        callMainNumber: '+966 11 123 4567',
        callSalesNumber: '+966 55 987 6543',
        emailTitle: 'Email Us',
        emailGeneralLabel: 'General:',
        emailSalesLabel: 'Sales Support:'
      },
      form: {
        title: 'Send an Inquiry',
        fullName: 'Full Name',
        companyName: 'Company Name',
        industry: 'Industry Sector',
        message: 'Message',
        submit: 'Submit Inquiry',
        fullNamePlaceholder: '',
        companyNamePlaceholder: '',
        messagePlaceholder: '',
        industryOptions: {
          oilGas: 'Oil & Gas',
          infrastructure: 'Infrastructure & Construction',
          mining: 'Mining & Metallurgy',
          manufacturing: 'Manufacturing',
          other: 'Other'
        }
      },
      sidebar: {
        businessHoursTitle: 'Business Hours',
        sundayThursday: 'Sunday - Thursday:',
        friday: 'Friday:',
        saturday: 'Saturday:',
        closed: 'Closed',
        connectTitle: 'Connect With Us',
        certifiedTitle: 'Certified Excellence'
      },



      toast: {
        success: 'Thank you for your inquiry. We will contact you soon.'
      }
    },
    // Footer
    footer: {
      description: 'Leading industrial materials trading partner in Saudi Arabia, dedicated to providing high-specification solutions for the Kingdom\'s growth.',
      navigation: 'Navigation',
      industries: 'Catalog',
      contact: 'Contact',
      navLinks: {
        home: 'Home',
        about: 'Who We Are',
        service: 'Our Solutions',
        career: 'Career',
        contact: 'Quality Compliance'
      },
      industryLinks: {
        oil: 'Pipes & Piping',
        petro: 'Valves & Fittings',
        power: 'Instrumentation',
        infrastructure: 'Structural Steel'
      },
      contactInfo: {
        location: 'Kingdom of Saudi Arabia Headquarters',
        email: 'info@amhbm.com',
        phone: '+966550473526'
      },
      copyright: '© 2024 Amal Mohammed Harthi for Building Materials. All rights reserved.'
    }
  },
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      service: 'الخدمات',
      career: 'الوظائف',
      contact: 'اتصل بنا'
    },
    // Home Page
    home: {
      hero: {
        bgImage: '/uploads/industry.png',
        visionLogo: SaudiVisionLogo,
        badge: 'المصدر الصناعي الرائد في المملكة',
        titleLine1: 'إمداد',
        titleEmphasis: 'مستقبل',
        titleLine2: 'الصناعة',
        subtitle: 'توريد استراتيجي لمواد البناء الصناعية، نربط الجودة العالمية بطموحات البنية التحتية في المملكة العربية السعودية.',
        explore: 'استكشف الحلول',
        requestQuote: 'اطلب عرض سعر'
      },
      badges: {
        delivery: 'توصيل في جميع أنحاء المملكة',
        certified: 'علامات تجارية معتمدة',
        iso: 'متوافق مع ISO 9001',
        support: 'دعم فني 24/7'
      },
      about: {
        image: '/uploads/workers.webp',
        label: 'سلطة راسخة',
        title: 'خبرة تشكل الأمم.',
        description: 'تعتبر AMHBM (أمل محمد الحارثي لمواد البناء) ركيزة أساسية في القطاع الصناعي السعودي. نحن أكثر من مجرد مورد، نحن شريك استراتيجي نوفر العمود الفقري لمشاريع البنية التحتية الضخمة والمجمعات الصناعية والإنجازات الهندسية المدنية.',
        vision: {
          title: 'رؤيتنا',
          text: 'أن نصبح القوة الصناعية الموثوقة الأكثر في دول مجلس التعاون الخليجي، لدعم العقد القادم من البنية التحتية.'
        },
        mission: {
          title: 'مهمتنا',
          text: 'تقديم دقة هندسية لا تقبل المساومة ومواد عالمية المستوى لكل ركن من أركان المملكة.'
        },
        legacyYears: '+100',
        legacyText: 'عميل'
      },
      solutions: {
        label: 'حلولنا',
        title: 'فئات هندسية عالية التأثير',
        description: 'مجموعة مختارة من المواد الصناعية من الشركات المصنعة العالمية الرائدة، مصممة للبيئات القاسية في الشرق الأوسط.',
        categories: {
          pipes: {
            image: '/uploads/1770008129-CS_pipes.webp',
            badge: 'توريد متميز',
            title: 'الأنابيب والتمديدات',
            desc: 'حلول سبائك وفولاذ عالي الجودة لأنظمة السوائل.'
          },
          valves: {
            image: '/uploads/1770009030-GateValves.webp',
            badge: 'تحكم دقيق',
            title: 'الصمامات والمشغلات',
            desc: 'أتمتة وتحكم يدوي لإدارة التدفق الحرجة.'
          },
          electrical: {
            image: '/uploads/1770013452-IndustrialElectrical.webp',
            badge: 'حلول الطاقة',
            title: 'البنية التحتية الكهربائية',
            desc: 'أنظمة أسلاك واحتواء قوية للمنشآت الصناعية.'
          }
        },
        services: {
          title: 'خدمات ذات قيمة مضافة',
          procurement: {
            title: 'التوريد الاستراتيجي',
            text: 'الاستفادة من شبكاتنا العميقة للعثور على المكونات الفنية التي يصعب الحصول عليها عالمياً.'
          },
          logistics: {
            title: 'الخدمات اللوجستية والتخزين',
            text: 'سلسلة توريد متكاملة مع مخزون محلي لنشر سريع في الموقع.'
          },
          industries: {
            oil: 'النفط والغاز',
            industry: 'الصناعة',
            energy: 'الطاقة',
            civil: 'البنية التحتية'
          }
        }
      },
      commitment: {
        image: '/uploads/statigic partner.png',
        label: 'التزامنا',
        title: 'امتثال قياسي لا هوادة فيه.',
        description: 'الجودة ليست مجرد خيار في AMHBM؛ إنها أساسنا. نلتزم بصرامة بالمعايير الدولية، مما يضمن أن كل مسمار وأنبوب وصمام يلبي المتطلبات الصارمة لعمالقة الصناعة في السعودية.',
        standards: {
          asme: 'معتمد',
          astm: 'قياسي',
          iso: 'متوافق',
          din: 'معتمد'
        }
      },
      vision2030: {
        logo: SaudiVisionLogo,
        title: 'تمهيد الطريق لرؤية السعودية 2030',
        text: 'بصفتنا مؤسسة سعودية فخورة، نحن محفزون للتغيير. من خلال توطين الخبرات وتوفير المكونات الحيوية لمشاريع التحول الوطني، تساهم AMHBM بشكل مباشر في مستقبل صناعي مستدام ومتنوع.',
        partner: 'شريك استراتيجي',
        link: 'تعرف على تأثيرنا'
      },
      contact: {
        titleLine1: 'أمّن سلسلة التوريد',
        titleEmphasis: 'الصناعية اليوم.',
        subtitle: 'شارك خبراء الصناعة الذين يفهمون تفاصيل السوق السعودي. دعنا نناقش مواصفات مشروعك.',
        cta1: 'طلب عرض سعر تفصيلي',
        cta2: 'استشر خبيرًا'
      }
    },
    // Service Page (Products & Categories)
    servicePage: {
      hero: {
        badge: 'الكتالوج الخاص بنا',
        titleLine1: 'حلول صناعية',
        titleEmphasis: 'شاملة',
        subtitle:
          'توريد مجموعة واسعة من المواد الميكانيكية والكهربائية والأنابيب عبر المملكة بمعايير جودة لا تقبل المساومة.',
        bgImage: ''
      },
      catalogNav: {
        title: 'كتالوج المنتجات',
        catalogPdf: '/uploads/AMHBM_Profile.pdf',
        items: {
          pipes: 'الأنابيب والأنابيب المجوفة',
          fittings: 'التوصيلات والوصلات',
          flanges: 'الفلنجات',
          valves: 'الصمامات والمشغلات',
          fire: 'أنظمة مكافحة الحريق ووصلات Grooved',
          instrumentation: 'ملحقات الأجهزة الدقيقة',
          fasteners: 'المسامير والصواميل',
          gaskets: 'الحشوات وأطقم العزل',
          electrical: 'الكهرباء الصناعية',
          telecom: 'اتصالات صناعية',
          sanitary: 'الأدوات الصحية',
          chemicals: 'المذيبات والمواد الكيميائية'
        }
      },
      overview: {
        title: 'نظرة عامة على الكتالوج الصناعي',
        description:
          'استكشف مجموعتنا الشاملة من المواد الصناعية عالية الأداء، المصممة لتلبية المعايير الصارمة للبنية التحتية في المملكة.'
      },
      sidebar: {
        title: 'تصفية البحث',
        materialType: {
          title: 'نوع المادة',
          options: ['الكربون الصلب', 'الفولاذ المقاوم للصدأ', 'سبائك الصلب', 'دوبلكس وسوبر دوبلكس']
        },
        standards: {
          title: 'المعايير الصناعية',
          options: ['ASME / ANSI', 'معايير ASTM', 'مواصفات API', 'DIN / EN']
        },
        help: {
          text: 'هل تحتاج إلى مواصفات محددة غير مدرجة؟ اتصل بفريق المشتريات لدينا.',
          link: 'إرسال استفسار فني'
        }
      },
      categories: {
        pipes: {
          title: 'الأنابيب والتمديدات',
          image: '/uploads/1770008129-CS_pipes.webp',
          description: 'مخزون متكامل من أنابيب الكربون ستيل والفولاذ المقاوم للصدأ والحديد الدكتايل، مصمم للتطبيقات ذات درجات الحرارة والضغوط العالية في قطاعات النفط والغاز والمياه.',
          items: [
            {
              name: 'أنابيب الكربون الصلب',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المعايير': 'ASME, ASTM, BS و DIN',
                'المادة': [
                  'أنابيب الكربون الصلب والسبائك (غير ملحومة)',
                  'أنابيب الكربون الصلب ERW (ملحومة)',
                  'أنابيب الكربون الصلب (ملحومة بالقوس المغمور)'
                ],
                'المقاسات': 'من ½ بوصة إلى 80 بوصة',
                'الجدول': '20/30/40/60/80/120/XXS/STD و XS',
                'الدرجة': [
                  'A53 Gr.B, A106 Gr.B, APL5L Gr.B X42, X52 & A333-6',
                  'A53-A, A53-b and APL 5L Gr.B',
                  'API 5L Gr.B, X52 and X60'
                ],
                'الطول': '6، 12 متر، DRL، SRL7'
              },
              footerNote: 'نوفر مقاسات ودرجات خاصة عند الطلب'
            },
            {
              name: 'أنابيب الفولاذ المقاوم للصدأ',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المعايير': 'ASME, ASTM, BS و DIN',
                'المادة': [
                  'الفولاذ المقاوم للصدأ (غير ملحوم)، الفولاذ المقاوم للصدأ الملحوم (ERW/EFW)'
                ],
                'المقاسات': 'من 1/8 بوصة إلى 12 بوصة',
                'الجدول': '10/20/40/80/120/XXS//SX/STD',
                'الدرجة': [
                  'A312-304/304L, 316/316L',
                  'A312-304/304L, 316/326L A358'
                ],
                'الطول': '6، 12 متر، DRL، SRL7'
              },
              footerNote: 'نوفر مقاسات ودرجات خاصة عند الطلب'
            },
            {
              name: 'أنابيب PVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المادة': 'PVC',
                'السماكة': 'SCH 40 / SCH 80 قياسي',
                'اللون': 'رمادي',
                'المقاسات': 'من ½ بوصة إلى 12 بوصة'
              }
            },
            {
              name: 'أنابيب UPVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المادة': 'UPVC',
                'المعايير': 'ASTM D1785',
                'المقاسات': 'من ½ بوصة إلى 12 بوصة'
              }
            },
            {
              name: 'أنابيب CPVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المادة': 'CPVC',
                'السماكة': 'SCH 80',
                'التطبيق': 'مياه ساخنة وباردة'
              }
            },
            {
              name: 'أنابيب HDPE',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المادة': 'بولي إيثيلين عالي الكثافة (HDPE)',
                'التصنيف': 'PN10, PN16, PN20, PN25',
                'المقاسات': '20 مم إلى 1200 مم'
              }
            },
            {
              name: 'أنابيب PPR',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المعايير': 'DIN 8077/8078',
                'العلامات التجارية': ['NIBCO', 'GULF PLAS', 'REDI', 'FIP', 'IPEX', 'NEPROPLAST']
              }
            },
            {
              name: 'أنابيب الحديد المجلفن',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                'المادة': 'حديد مجلفن',
                'المعايير': 'BS 1387 Class A, B, C',
                'المقاسات': 'من ½ بوصة إلى 6 بوصة'
              }
            }
          ]
        },
        fittings: {
          title: 'التوصيلات الصناعية',
          image: '/uploads/1770008921-FittingsBackgroundimage.webp',
          description: 'توصيلات صناعية عالية الجودة لتوصيلات الأنابيب السلسة. متوفرة بمواد ومواصفات مختلفة لتلبية متطلبات المشاريع الصارمة.',
          items: [
            {
              name: 'وصلات اللحام التناكبي الكربون الصلب',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['أكواع (45°/90°)', 'تيهات', 'نقاصات', 'سدادات'],
                'المادة': ['كربون صلب (WPB)', 'WPL6'],
                'المعايير': ['ASME B16.9', 'MSS SP-75']
              }
            },
            {
              name: 'وصلات اللحام التناكبي ستانلس ستيل',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['أكواع', 'تيهات', 'نقاصات', 'سدادات'],
                'المادة': ['ستانلس ستيل (304/304L, 316/316L)'],
                'المعايير': ['ASME B16.9', 'ASTM A403']
              }
            },
            {
              name: 'وصلات كربون صلب مطروقة',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['لحام مقبس', 'مسنن'],
                'المادة': ['كربون صلب (A105, A350 LF2)'],
                'المعايير': ['ASME B16.11', 'BS 3799']
              }
            },
            {
              name: 'وصلات ستانلس ستيل مطروقة',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['لحام مقبس', 'مسنن'],
                'المادة': ['ستانلس ستيل (F304/L, F316/L)'],
                'المعايير': ['ASME B16.11']
              }
            },
            {
              name: 'وصلات حديد مطاوع مطروقة',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['أكواع', 'تيهات', 'صلبان', 'وصلات'],
                'المادة': ['حديد مطاوع'],
                'المعايير': ['ASME B16.3', 'BS EN 10242']
              }
            },
            {
              name: 'وصلات PVC/CPVC/UPVC',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['مقبس', 'مسنن', 'فلنجة'],
                'المادة': ['PVC', 'CPVC', 'UPVC'],
                'المعايير': ['ASTM D2466', 'ASTM D2467', 'ASTM F439']
              }
            },
            {
              name: 'وصلات HDPE',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['لحام تناكبي', 'لحام كهربائي', 'ضغط'],
                'المادة': ['HDPE (PE100, PE80)'],
                'المعايير': ['ISO 4427', 'EN 12201']
              }
            },
            {
              name: 'وصلات PPR',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['لحام مقبس', 'وصلة انتقالية'],
                'المادة': ['PPRC'],
                'المعايير': ['DIN 8077/8078']
              }
            },
            {
              name: 'وصلات الحديد المجلفن',
              type: 'detailed',
              images: [
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['أكواع', 'تيهات', 'حلمات', 'وصلات'],
                'المادة': ['حديد مجلفن'],
                'المعايير': ['BS 1387', 'BS EN 10255']
              }
            }
          ]
        },
        flanges: {
          title: 'الفلنجات',
          image: '/uploads/1770008936-FlangesBgImage.jpg',
          description: 'فلنجات عالية الجودة تضمن توصيلات مانعة للتسرب للتطبيقات الصناعية عالية الضغط.',
          items: [
            {
              name: 'فلنجات الكربون الصلب',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                'الأنواع': ['رقبة ملحومة', 'منزلقة', 'عماء', 'لحام مقبس', 'مسننة'],
                'التصنيف': ['150#', '300#', '600#', '900#', '1500#', '2500#'],
                'الوجه': ['RF (وجه بارز)', 'RTJ (وصلة حلقية)', 'FF (وجه مسطح)'],
                'المادة': ['كربون صلب']
              }
            },
            {
              name: 'فلنجات ستانلس ستيل',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                'الأنواع': ['رقبة ملحومة', 'منزلقة', 'عماء', 'لحام مقبس', 'مسننة'],
                'التصنيف': ['150#', '300#', '600#', '900#', '1500#', '2500#'],
                'الوجه': ['RF (وجه بارز)', 'RTJ (وصلة حلقية)', 'FF (وجه مسطح)'],
                'المادة': ['ستانلس ستيل (304/304L, 316/316L)']
              }
            },
            {
              name: 'فلنجات الحديد المطاوع',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                'الأنواع': ['فلنجات ألواح', 'Table D/E/F'],
                'التصنيف': ['PN6', 'PN10', 'PN16', 'PN25', 'PN40'],
                'الوجه': ['RF', 'FF'],
                'المادة': ['حديد مطاوع (Mild Steel)']
              }
            },
            {
              name: 'فلنجات الحديد المجلفن',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                'الأنواع': ['مسننة', 'منزلقة'],
                'التصنيف': ['150#', '300#', 'PN16'],
                'الوجه': ['RF', 'FF'],
                'المادة': ['حديد مجلفن']
              }
            },
            {
              name: 'فلنجات PVC/CPVC/UPVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                'الأنواع': ['فان ستون', 'عماء', 'قطعة واحدة'],
                'التصنيف': ['SCH 80', 'PN10', 'PN16'],
                'الوجه': ['FF'],
                'المادة': ['PVC', 'CPVC', 'UPVC']
              }
            },
            {
              name: 'فلنجات HDPE',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
              ],
              specs: {
                'الأنواع': ['نهاية قصيرة (Stub End)', 'حلقة دعم'],
                'التصنيف': ['SDR 11', 'SDR 17', 'PN10', 'PN16'],
                'الوجه': ['FF'],
                'المادة': ['HDPE (PE100)']
              }
            }
          ]
        },
        valves: {
          title: 'الصمامات والمشغلات',
          image: '/uploads/1770009030-GateValves.webp',
          description: 'حلول متقدمة للتحكم في التدفق تشمل صمامات البوابة والكرة وعدم الرجوع والفراشة، متوفرة بهياكل مطروقة ومسبوكة مع خيارات تشغيل يدوي أو مؤتمت.',
          items: [
            {
              name: 'صمامات البوابة',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPVC/CPVC/HDPE/PPR']
              }
            },
            {
              name: 'صمامات كروية',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'صمامات عدم الرجوع',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'صمامات الفراشة',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'صمامات الأمان',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'صمامات إبرية',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS', 'PVC/UPV/CPVC/HDPE']
              }
            },
            {
              name: 'صمامات تخفيض الضغط',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['CS', 'SS', 'WCB', 'CAST IRON', 'BRONZE', 'BRASS']
              }
            },
            {
              name: 'صمامات الغشاء',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                'المواد': ['PVC/UPVC/CPVC/HDPE']
              }
            }
          ]
        },
        fire: {
          title: 'مكافحة الحريق',
          image: '/uploads/1770009990-FireFightings.jpg',
          description: 'منظومات متكاملة لمكافحة الحريق تشمل الحنفيات والرشاشات ولوحات إنذار الحريق، متوافقة بالكامل مع متطلبات الدفاع المدني ومعايير NFPA.',
          items: [
            {
              name: 'أنظمة الرش الآلي',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
              ],
              specs: {
                'الأنواع': ['متدلي', 'قائم', 'جداري', 'مخفي'],
                'التشطيب': ['نحاس', 'كروم', 'أبيض'],
                'الاعتمادات': ['مدرج UL', 'معتمد FM', 'معتمد من الدفاع المدني'],
                'العناصر': ['صمامات فحص الإنذار', 'صمامات التحكم في المنطقة', 'خزانات خراطيم الحريق', 'طفايات الحريق']
              }
            },
            {
              name: 'الصمامات وحنفيات الحريق',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
              ],
              specs: {
                'الأنواع': ['صمامات بوابة OS&Y', 'صمامات فراشة', 'صمامات عدم رجوع', 'صمامات البسطة', 'مداخل التغذية'],
                'المادة': ['حديد دكتايل', 'برونز', 'حديد الزهر'],
                'الضغط': 'PN16, PN25',
                'الاعتمادات': ['UL/FM']
              }
            },
            {
              name: 'التجهيزات المخددة',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
              ],
              specs: {
                'العناصر': ['وصلات (صلبة/مرنة)', 'أكواع', 'تيهات', 'نقاصات', 'فلنجات', 'تيهات ميكانيكية'],
                'المادة': 'حديد دكتايل ASTM A536',
                'الطلاء': 'مطلي أحمر / مجلفن',
                'الاعتمادات': 'معتمد UL/FM'
              }
            }
          ]
        },
        fasteners: {
          title: 'المسامير والمثبتات',
          image: '/uploads/1770012306-STUDBgImage.webp',
          description: 'مسامير ومثبتات صناعية عالية القوة مصممة للتوصيلات الهيكلية والأنابيب الحرجة.',
          items: [
            {
              name: 'المسامير والمثبتات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'المنتجات': ['مسامير ملولبة الطرفين', 'مسامير سداسية', 'مسامير تثبيت', 'صواميل', 'وردات', 'قضبان مسننة', 'مسامير على شكل U'],
                'المادة': ['كربون الصلب', 'ستانلس ستيل (304/316)', 'سبائك الصلب', 'دوبلكس', 'إنكونيل'],
                'الدرجة': ['A193 B7/B7M', 'A193 B8/B8M', 'A320 L7/L7M', 'درجة 8.8, 10.9'],
                'الطلاء': ['مطلي بالزنك', 'مجلفن بالغمس الساخن', 'مطلي بـ PTFE / Xylan', 'مطلي بالكادميوم']
              },
              footerNote: 'نوفر طلاءات ومواد خاصة عند الطلب'
            }
          ]
        },
        gaskets: {
          title: 'الحشوات وأطقم العزل',
          image: '/uploads/1770012581-GasketsBgImage.jpg',
          description: 'حلول عزل شاملة تشمل الحشوات وأطقم العزل لحماية الفلنجات ومنع التسرب.',
          items: [
            {
              name: 'الجوانات ومواد العزل',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['جوانات حلزونية', 'جوانات حلقية', 'ألوح خالية من الأسبستوس', 'جوانات مطاطية', 'أطقم عزل'],
                'المادة': ['فولاذ مقاوم للصدأ', 'حديد مطاوع', 'غرافيت', 'PTFE', 'نيوبرين/EPDM'],
                'المقاسات': 'مقاسات قياسية ومخصصة',
                'الضغط': 'فئة 150 إلى 2500'
              },
              footerNote: 'نوفر حلول عزل مخصصة عند الطلب'
            }
          ]
        },
        sanitary: {
          title: 'الأدوات الصحية',
          image: '/uploads/1770014085-Sanitary.jpg',
          description: 'أنظمة صحية متينة وصحية تشمل حلول الصرف والسباكة للمرافق التجارية والصناعية.',
          items: [
            {
              name: 'الأدوات الصحية',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                'العناصر': ['خلاط', 'صنبور', 'أحواض غسيل وخزانات صرف', 'مراحيض', 'إكسسوارات الحمام']
              }
            },
            {
              name: 'مصارف',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['مصرف أرضي ومساحات', 'مصرف سقف', 'مصرف خندقي هيدرو-فلو', 'حوض أرضي صحي', 'بالوعات', 'شبكات أرضية']
              }
            }
          ]
        },
        chemicals: {
          title: 'المذيبات والمواد الكيميائية',
          image: '/uploads/1770014336-Solvent&Chemicals.webp',
          description: 'مواد لاصقة وكيماويات إنشائية متخصصة للحماية والربط وتجديد الأسطح، بما في ذلك حلول الأرضيات والخرسانة والعزل.',
          items: [
            {
              name: 'غراء PVC',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'غراء PVC احترافي لربط الأنابيب بشكل آمن.'
            },
            {
              name: 'غراء CPVC',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'غراء CPVC عالي الحرارة لأنظمة الأنابيب الصناعية.'
            },
            {
              name: 'غراء UPVC',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'غراء UPVC شديد التحمل لتطبيقات الضغط والصرف.'
            },
            {
              name: 'حلول التجديد',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'حلول متقدمة لترميم وإطالة عمر البنية التحتية.'
            },
            {
              name: 'حلول الأرضيات',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'أنظمة أرضيات إيبوكسي وبولي يوريثين متينة للاستخدام الصناعي.'
            },
            {
              name: 'حلول الخرسانة',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'إضافات وملاط إصلاح لتقوية الهياكل الخرسانية.'
            },
            {
              name: 'حلول العزل المائي',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'أغشية وطلاءات عزل مائي شاملة لجميع الأسطح.'
            },
            {
              name: 'حلول الختم والربط',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'مواد مانعة للتسرب ومواد لاصقة عالية الأداء لوصلات البناء.'
            },
            {
              name: 'حلول الأسقف',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp'
              ],
              description: 'أنظمة تسقيف متقدمة للحماية الحرارية ومنع التسرب.'
            }
          ]
        },
        tools: {
      title: 'أدوات البناء والصناعة',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
      description: 'أدوات يدوية وكهربائية احترافية وأدوات صناعية متخصصة مصممة لتحمل بيئات العمل الشاقة في الإنشاءات والصيانة.',
      items: [
            {
              name: 'الأدوات اليدوية',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['مطارق', 'مفكات', 'زراديات', 'مفاتيح ربط', 'أدوات قياس', 'أدوات قطع'],
                'العلامات التجارية': ['Stanley', 'Snap-on', 'Ridgid', 'Fluke'],
                'التطبيقات': ['إنشاءات عامة', 'أعمال كهربائية', 'سباكة', 'صيانة ميكانيكية']
              }
            },
            {
              name: 'الأدوات الكهربائية',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['دريل (ثواقب)', 'صواريخ (جلخ)', 'مناشير', 'مفاتيح صدم', 'ماكينات صنفرة', 'مطارق هدم'],
                'مصدر الطاقة': ['سلكي', 'لاسلكي (18V/20V/60V)', 'هوائي'],
                'العلامات التجارية': ['DeWalt', 'Makita', 'Bosch', 'Hilti', 'Milwaukee']
              }
            },
            {
              name: 'أدوات صناعية متخصصة',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['آلات قلاووظ الأنابيب', 'أدوات هيدروليكية', 'معدات لحام', 'مولدات', 'ضواغط'],
                'العلامات التجارية': ['Ridgid', 'Rothenberger', 'Miller', 'Lincoln Electric', 'Ingersoll Rand']
              }
            }
          ]
        },
        instrumentation: {
          title: 'الأجهزة الدقيقة',
          image: '/uploads/1770011999-InstrumentationAccessoriesBgImage.jpg',
          description: 'ملحقات وتجهيزات دقيقة تضمن القياس والتحكم والربط الموثوق في دوائر القياس والتحكم الحساسة.',
          items: [
            {
              name: 'مقاييس الضغط',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                'الأنواع': ['أنبوب بوردون', 'غشاء عازل', 'ضغط تفاضلي', 'مقاييس رقمية'],
                'المادة': ['ستانلس ستيل 316L', 'مونيل', 'هاستيلوي', 'نحاس'],
                'مقاس المينا': ['2.5 بوصة', '4 بوصة', '6 بوصة'],
                'الدقة': ['1.0%', '0.5%', '0.25%'],
                'العلامات التجارية': ['WIKA', 'Ashcroft', 'Nuova Fima']
              }
            },
            {
              name: 'الأنابيب وتجهيزات الأنابيب الدقيقة',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                'الأنواع': ['أنابيب غير ملحومة', 'وصلات ضغط (حلقتين)'],
                'المادة': ['ستانلس ستيل 316/316L', 'سوبر دوبليكس', 'إنكونيل 625'],
                'المقاسات': ['1/16 بوصة إلى 1 بوصة', '3 مم إلى 25 مم'],
                'الضغط': 'يصل إلى 15,000 PSI',
                'العلامات التجارية': ['Swagelok', 'Parker', 'Hy-Lok']
              }
            },
            {
              name: 'الصمامات الإبرية والمتشعبة',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                'الأنواع': ['صمامات إبرية', 'صمامات كروية', 'صمامات عدم رجوع', 'متشعبات 2/3/5 اتجاهات', 'حجز وتصريف مزدوج'],
                'المادة': ['ستانلس ستيل', 'كربون ستيل', 'سبيكة 400'],
                'التوصيل': ['NPT', 'ضغط', 'لحام مقبس'],
                'الحشو': ['PTFE', 'غرافيت (حرارة عالية)']
              }
            }
          ]
        },
        electrical: {
          title: 'المواد الكهربائية',
          image: '/uploads/1770013452-IndustrialElectrical.webp',
          description: 'كابلات جهد منخفض ومتوسط وعالٍ مع حلول متكاملة للإنهاء والحماية والتأريض لتوزيع طاقة آمن وموثوق.',
          items: [
            {
              name: 'الكابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['كابلات جهد منخفض', 'جهد متوسط', 'جهد عالي', 'كابلات مرنة']
              }
            },
            {
              name: 'عروات الكابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'المواد': ['نحاس', 'ألمنيوم', 'برونز', 'ثنائي المعدن']
              }
            },
            {
              name: 'روابط الكابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['PVC', 'ستانلس ستيل', 'PVC مطلي']
              }
            },
            {
              name: 'التجهيزات والملحقات الكهربائية',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'العناصر': [
                    'قنوات كهربائية (EMT, RIGID, PVC/UPVC/CPVC)',
                    'مرفقات مقاومة للانفجار',
                    'قواطع دوائر',
                    'صناديق كهربائية',
                    'موصلات الأسلاك',
                    'علامات الأسلاك',
                    'جلب الكابلات (بلاستيك/نايلون، نحاس، ستانلس ستيل، ألمنيوم)',
                    'أنابيب الانكماش الحراري',
                    'أطقم الإنهاء والوصل'
                ]
              }
            },
            {
              name: 'حوامل وسلالم الكابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['نوع السلم', 'نوع مثقب', 'قاع صلب', 'شبكة سلكية', 'قناة']
              }
            }
          ]
        },
        telecom: {
          title: 'اتصالات صناعية',
          image: '/uploads/telecom.png',
          description: 'حلول ألياف بصرية وأنظمة دكتات تتيح بنية تحتية قوية لشبكات الاتصالات الصناعية.',
          items: [
            {
              name: 'الاتصالات الصناعية',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                'العناصر': [
                    'كابلات الألياف البصرية',
                    'سدادات الدكتات',
                    'علامات الكابلات الأرضية',
                    'أنابيب مموجة وغير مموجة',
                    'أشرطة تحذير قابلة للكشف وغير قابلة للكشف'
                ]
              }
            },
            {
              name: 'ملحقات القنوات الكهربائية المطلية',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['قنوات وتجهيزات مطلية بـ PVC', 'قنوات وتجهيزات مطلية بالإيبوكسي', 'قنوات وتجهيزات مطلية بالبودرة']
              }
            },
            {
              name: 'دعم التأريض',
              type: 'detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                'العناصر': ['قضبان التأريض', 'ألواح التأريض', 'أسلاك/أشرطة التأريض', 'مشابك وموصلات', 'غرف التفتيش الأرضية']
              }
            }
          ]
        },
        building: {
          title: 'مواد البناء',
          image: '/uploads/workers.webp',
          description: 'مواد إنشائية ومعمارية تشمل الخرسانة والصلب والخشب والمنتجات البنائية لعزل وتكسية المباني بالكامل.',
          items: [
            {
              name: 'الأخشاب ومنتجاتها',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأخشاب': ['خشب أبيض (تنوب/صنوبر)', 'خشب أحمر', 'خشب صلب (ميرانتي، بلوط، تيك)', 'خشب معاكس (تجاري/بحري)', 'MDF'],
                'الاستخدام': ['هيكلي', 'قوالب خرسانية', 'نجارة', 'ديكور'],
                'المنشأ': ['كندا', 'رومانيا', 'النمسا', 'ماليزيا', 'الصين']
              }
            },
            {
              name: 'مواد العزل',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأنواع': ['صوف زجاجي', 'صوف صخري', 'بوليسترين مبثوق (XPS)', 'بوليسترين ممدد (EPS)', 'رغوة رش'],
                'التطبيقات': ['عزل حراري', 'عزل صوتي', 'تسقيف', 'دكتات تكييف'],
                'الأشكال': ['لفات', 'ألواح', 'مقاطع أنابيب']
              }
            },
            {
              name: 'منتجات الحديد والصلب',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'المنتجات': ['حديد تسليح (قضبان مشوهة)', 'جسور هيكلية (H/I)', 'قنوات (UPN)', 'زوايا', 'قضبان مسطحة', 'شبك حديد'],
                'المعايير': ['ASTM A615', 'BS 4449', 'ASTM A36', 'S275/S355'],
                'المنشأ': ['السعودية (سابك/الراجحي)', 'مستورد']
              }
            },
            {
              name: 'الجبس وملحقاته',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الألواح': ['ألواح جبس عادية', 'مقاوم للرطوبة (أخضر)', 'مقاوم للحريق (وردي/أحمر)'],
                'القطاعات': ['قوائم', 'مسارات', 'قنوات تثبيت', 'زوايا ركنية', 'زوايا ظل'],
                'الملحقات': ['معجون فواصل', 'براغي جبس', 'شريط فواصل']
              }
            },
            {
              name: 'الأسمنت والركام',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                'الأسمنت': ['أسمنت بورتلاندي عادي (Type I)', 'مقاوم للكبريتات (Type V)', 'أسمنت أبيض'],
                'الركام': ['رمل (أبيض/أحمر)', 'بحص (3/8"، 3/4")', 'أساس طريق'],
                'الإضافات': ['إضافات خرسانية', 'مواد معالجة']
              }
            }
          ]
        },
      },
      badges: {
        aramcoApproved: 'معتمد من أرامكو',
        sabicReady: 'جاهز لـ SABIC',
        api6d: 'معتمد وفق API 6D',
        ulListed: 'معتمد UL',
        fmApproved: 'معتمد FM'
      },

      viewRange: 'عرض النطاق الكامل',
      cta: 'استكشف المزيد من الفئات'
    },
    // About Page
    aboutPage: {
      hero: {
        bgImage: '/uploads/industry.png',
        badge: 'تميز راسخ',
        titleLine1: 'من',
        titleEmphasis: 'نحن.',
        subtitle: 'تعتبر AMHBM ركيزة من ركائز سلسلة التوريد الصناعية في المملكة العربية السعودية، حيث توفر المواد الأساسية التي تبني مستقبل المملكة.'
      },
      pillars: {
        integrity: {
          label: 'ركيزتنا',
          title: 'نزاهة لا تتزعزع'
        },
        quality: {
          label: 'معيارنا',
          title: 'جودة هندسية'
        },
        commitment: {
          label: 'وعدنا',
          title: 'التزام حقيقي'
        }
      },
      visionMission: {
        vision: {
          title: 'الرؤية',
          text: 'أن نكون الشريك الاستراتيجي الأول في التطور الصناعي في الشرق الأوسط، والمشهود له بوضع المعيار الذهبي في التوريد والخبرة الفنية والموثوقية. نتصور مستقبلاً تكون فيه AMHBM مرادفاً للسلامة الهيكلية لمشاريع السعودية الأكثر طموحاً.'
        },
        mission: {
          title: 'المهمة',
          text: 'مهمتنا هي تمكين القطاعات الصناعية في المملكة من خلال توفير مواد بناء عالية المواصفات عبر سلسلة توريد سلسة ومتكاملة عالمياً. نحن ملتزمون بضمان السلامة والكفاءة والاستدامة في كل مكون نقدمه لشركائنا.'
        }
      },
      quote: {
        image: '/uploads/workers.webp',
        imageOverlayTitle: 'رؤية 2030',
        imageOverlaySubtitle: 'المملكة العربية السعودية',
        text1: 'نحن لسنا مجرد موردين؛ نحن أساس',
        textEmphasis: 'رؤية السعودية 2030.',
        desc1: 'في AMHBM، ندرك أن دورنا يتجاوز التجارة البسيطة. مع تحول المملكة العربية السعودية التاريخي، تشكل المواد التي نقدمها العمود الفقري المادي لتقدم أمتنا.',
        desc2: 'التزامنا بالجودة شخصي. كل صمام، وكل أنبوب، وكل مكون كهربائي نورده يتم فحصه للتأكد من أنه يلبي المتطلبات الصارمة للبنية التحتية المستقبلية للمملكة. معاً، نبني إرثاً من التميز.',
        role: 'الرئيس التنفيذي والعضو المنتدب',
        company: 'أمل محمد الحارثي لمواد البناء'
      },
      advantage: {
        label: 'ميزة استراتيجية',
        title: 'لماذا يختار الشركاء AMHBM',
        global: {
          title: 'شراكات عالمية',
          text: 'وصول مباشر إلى مصنعين من الدرجة الأولى في أوروبا وآسيا والأمريكتين، مما يضمن مواد أصلية وعالية الأداء.'
        },
        logistics: {
          title: 'تميز لوجستي',
          text: 'شبكة توزيع قوية عبر المملكة العربية السعودية تضمن التسليم في الوقت المحدد حتى لمواقع المشاريع الأكثر نائية.'
        },
        technical: {
          title: 'خبرة فنية',
          text: 'يقدم فريق المتخصصين لدينا استشارات فنية عميقة لضمان مطابقة المواد تماماً للمواصفات الهندسية.'
        }
      },
      vision2030: {
        logo: SaudiVisionLogo,
        label: 'التوافق الوطني',
        titleLine1: 'ملتزمون بـ',
        titleEmphasis: 'رؤية السعودية 2030',
        text: 'بينما تبني السعودية للمستقبل، توفر AMHBM المكونات الصناعية الحيوية التي تشغل البنية التحتية للمملكة. من المشاريع العملاقة إلى المدن الصناعية، سلسلتنا للتوريد هي العمود الفقري للنمو التحويلي وأهداف التنويع الاقتصادي للأمة.'
      }
    },
    // Career Page (Existing)
    careerPage: {
      hero: {
        image: '/uploads/industry.png',
        badge: 'فرص وظيفية',
        titleLine1: 'اصنع مستقبل',
        titleEmphasis: 'الصناعة السعودية',
        titleLine2: 'معنا',
        subtitle:
          'انضم إلى فريق من الخبراء الملتزمين بالتميز في سلسلة الإمداد الصناعية والبنية التحتية. نُمكّن نمو المملكة من خلال الابتكار والنزاهة.',
        cta: 'استكشف الوظائف المتاحة'
      },
      culture: {
        badge: 'الحياة في AMHBM',
        title: 'ثقافة تقود التقدم.',
        description:
          'تقوم ثقافتنا على الابتكار والنزاهة والانسجام العميق مع رؤية السعودية 2030. نوفّر بيئة يلتقي فيها التطور المهني بالتأثير الوطني.',
        cards: {
          collaboration: {
            image: '/uploads/workers.webp',
            title: 'العمل الجماعي',
            text: 'نعزز روح النجاح المشترك في كل مشروع.'
          },
          workshops: {
            image: '/uploads/statigic partner.png',
            title: 'ورش عمل',
            text: 'تعلّم مستمر وتطوير مهني متواصل.'
          },
          impact: {
            image: '/uploads/industry.png',
            title: 'أثر في مواقع العمل',
            text: 'نشاهد النتائج الملموسة لتوريدنا الصناعي على أرض الواقع.'
          },
          vision: {
            image: '/uploads/workers.webp',
            title: 'رؤية 2030',
            text: 'ملتزمون بالتحول الصناعي للمملكة.'
          }
        }
      },
      benefits: {
        items: {
          compensation: {
            title: 'تعويضات تنافسية',
            text: 'مكافأة التميز بحزم ورواتب ومزايا رائدة في القطاع.'
          },
          growth: {
            title: 'نمو مهني',
            text: 'مسارات مهنية واضحة ودعم للشهادات المتقدمة.'
          },
          impact: {
            title: 'أثر سعودي مركّز',
            text: 'مساهمة مباشرة في البنية التحتية والمشاريع العملاقة في المملكة.'
          },
          culture: {
            title: 'ثقافة شاملة',
            text: 'بيئة عمل متنوعة يُقدَّر فيها صوت كل فرد.'
          }
        }
      },
      applicationForm: {
        firstName: 'الاسم الأول',
        firstNamePlaceholder: 'أدخل اسمك الأول هنا',
        lastName: 'اسم العائلة',
        lastNamePlaceholder: 'اسم العائلة',
        dateOfBirth: 'تاريخ الميلاد',
        dateOfBirthPlaceholder: 'يوم-شهر-سنة',
        phoneNumber: 'رقم الجوال',
        phoneNumberPlaceholder: 'مثال: +966-5xxxxxxx',
        gender: 'الجنس',
        genderOptions: {
          male: 'ذكر',
          female: 'أنثى',
          preferNotToSay: 'أفضل عدم الإفصاح'
        },
        email: 'البريد الإلكتروني',
        emailPlaceholder: 'البريد الإلكتروني',
        fileUpload: 'رفع الملف',
        fileUploadButton: 'اختر ملفاً',
        fileUploadPlaceholder: 'لم يتم اختيار ملف'
      },

      cta: {
        title: 'لا تجد وظيفة مناسبة؟',
        text: 'أرسل إلينا سيرتك الذاتية لفرص مستقبلية. نبحث دائمًا عن المواهب المتميزة للانضمام إلى مهمتنا الصناعية.',
        button: 'ارفع سيرتك الذاتية'
      }
    },
    // Contact Page (Existing)
    contactPage: {
      hero: {
        image: '/uploads/industry.png',
        badge: 'تواصل معنا',
        titleLine1: 'تواصل مع',
        titleEmphasis: 'خبرائنا الصناعيين',
        subtitle:
          'من توريد المواد إلى دعم المشاريع، نحن هنا لدعم مهمتك الصناعية في المملكة.'
      },
      cards: {
        visitTitle: 'زورونا',
        visitLine1: 'المقر الرئيسي بالرياض',
        visitLine2: 'حي الملز، طريق الملك عبدالعزيز',
        visitLine3: 'الرياض، المملكة العربية السعودية',
        callTitle: 'اتصل بنا',
        callMainLabel: 'المكتب الرئيسي:',
        callSalesLabel: 'قسم المبيعات:',
        emailTitle: 'راسلنا',
        emailGeneralLabel: 'عام:',
        emailSalesLabel: 'دعم المبيعات:'
      },
      form: {
        title: 'أرسل استفسارك',
        fullName: 'الاسم الكامل',
        companyName: 'اسم الشركة',
        industry: 'القطاع الصناعي',
        message: 'الرسالة',
        submit: 'إرسال الاستفسار',
        fullNamePlaceholder: '',
        companyNamePlaceholder: '',
        messagePlaceholder: '',
        industryOptions: {
          oilGas: 'النفط والغاز',
          infrastructure: 'البنية التحتية والإنشاءات',
          mining: 'التعدين والمعادن',
          manufacturing: 'التصنيع',
          other: 'أخرى'
        }
      },
      sidebar: {
        businessHoursTitle: 'ساعات العمل',
        sundayThursday: 'من الأحد إلى الخميس:',
        friday: 'الجمعة:',
        saturday: 'السبت:',
        closed: 'مغلق',
        connectTitle: 'تواصل معنا',
        certifiedTitle: 'اعتمادات الجودة'
      },



      toast: {
        success: 'شكرًا لاستفسارك، سنتواصل معك في أقرب وقت.'
      }
    },
    // Footer
    footer: {
      description: 'شريك تجارة المواد الصناعية الرائد في المملكة العربية السعودية، مكرس لتقديم حلول عالية المواصفات لنمو المملكة.',
      navigation: 'الملاحة',
      industries: 'الكتالوج',
      contact: 'اتصال',
      navLinks: {
        home: 'الرئيسية',
        about: 'من نحن',
        service: 'حلولنا',
        career: 'الوظائف',
        contact: 'الامتثال للجودة'
      },
      industryLinks: {
        oil: 'الأنابيب والتمديدات',
        petro: 'الصمامات والتجهيزات',
        power: 'الأجهزة الدقيقة',
        infrastructure: 'الفولاذ الهيكلي'
      },
      contactInfo: {
        location: 'DAMMAM Al Qadisiyah Dist. Shaddad Ibn Aws',
        email: 'info@amhbm.com',
        phone: '+966 55 047 3526'
      },
      copyright: '© 2024 أمل محمد الحارثي لمواد البناء. جميع الحقوق محفوظة.'
    }
  },
  lo: {
    // Navigation
    nav: {
      home: '[LO] HOME',
      about: '[LO] WHO WE ARE',
      service: '[LO] PRODUCT',
      career: '[LO] CAREER',
      contact: '[LO] CONTACT'
    },
    // Home Page
    home: {
      hero: {
        bgImage: '/uploads/industry.png',
        visionLogo: SaudiVisionLogo,
        badge: '[LO] Premier Industrial Sourcing KSA',
        titleLine1: '[LO] Supplying the',
        titleEmphasis: '[LO] Future',
        titleLine2: '[LO] of Industry',
        subtitle: '[LO] Strategic industrial building materials trading, bridging global quality with Saudi Arabia\'s infrastructure ambitions.',
        explore: '[LO] Explore Solutions',
        requestQuote: '[LO] Request a Quote'
      },
      badges: {
        delivery: '[LO] KSA-Wide Delivery',
        certified: '[LO] Certified Brands',
        iso: '[LO] ISO 9001 Compliant',
        support: '[LO] 24/7 Technical Support'
      },
      about: {
        image: '/uploads/workers.webp',
        label: '[LO] Established Authority',
        title: '[LO] Expertise That Shapes Nations.',
        description: '[LO] AMHBM (Amal Mohammed Harthi for Building Materials) stands as a cornerstone of Saudi Arabia’s industrial sector. More than a trader, we are a strategic partner providing the backbone for massive infrastructure projects, industrial complexes, and civil engineering feats.',
        vision: {
          title: '[LO] Our Vision',
          text: '[LO] To be the most trusted industrial sourcing powerhouse in the GCC, fueling the next decade of infrastructure.'
        },
        mission: {
          title: '[LO] Our Mission',
          text: '[LO] Delivering uncompromised engineering precision and world-class materials to every corner of the Kingdom.'
        },
        legacyYears: '[LO] 100+',
        legacyText: '[LO] Clients'
      },
      solutions: {
        label: '[LO] Our Solutions',
        title: '[LO] High-Impact Engineering Categories',
        description: '[LO] Curated selection of industrial grade materials sourced from leading global manufacturers, tailored for the harsh environments of the Middle East.',
        categories: {
          pipes: {
            image: '/uploads/1770008129-CS_pipes.webp',
            badge: '[LO] Premium Sourcing',
            title: '[LO] Pipes & Tubing',
            desc: '[LO] Specialized alloy and high-grade steel solutions for fluid systems.'
          },
          valves: {
            image: '/uploads/1770009030-GateValves.webp',
            badge: '[LO] Precision Control',
            title: '[LO] Valves',
            desc: '[LO] Automation and manual control for critical flow management.'
          },
          electrical: {
            image: '/uploads/1770013452-IndustrialElectrical.webp',
            badge: '[LO] Power Solutions',
            title: '[LO] Electrical Infrastructure',
            desc: '[LO] Robust wiring and containment systems for industrial plants.'
          }
        },
        services: {
          title: '[LO] Value-Added Services',
          procurement: {
            title: '[LO] Strategic Procurement',
            text: '[LO] Leveraging deep networks to find hard-to-source technical components globally.'
          },
          logistics: {
            title: '[LO] Logistics & Warehousing',
            text: '[LO] Integrated supply chain with localized inventory for rapid site deployment.'
          },
          industries: {
            oil: '[LO] Oil & Gas',
            industry: '[LO] Industry',
            energy: '[LO] Energy',
            civil: '[LO] Civil Infra'
          }
        }
      },
      commitment: {
        image: '/uploads/statigic partner.png',
        label: '[LO] Our Commitment',
        title: '[LO] Uncompromising Standard Compliance.',
        description: '[LO] Quality is not just a checkbox at AMHBM; it is our foundation. We strictly adhere to international benchmarks, ensuring that every bolt, pipe, and valve meets the rigorous demands of Saudi Arabia\'s industrial giants.',
        standards: {
          asme: '[LO] Certified',
          astm: '[LO] Standard',
          iso: '[LO] Compliant',
          din: '[LO] Approved'
        }
      },
      vision2030: {
        logo: SaudiVisionLogo,
        title: '[LO] Paving the Way for Saudi Vision 2030',
        text: '[LO] As a proud Saudi enterprise, we are catalysts for change. By localizing expertise and providing the critical components for National Transformation projects, AMHBM is directly contributing to a sustainable, diversified industrial future.',
        partner: '[LO] Strategic Partner',
        link: '[LO] Learn about our impact'
      },
      contact: {
        titleLine1: '[LO] Secure Your Industrial',
        titleEmphasis: '[LO] Supply Chain Today.',
        subtitle: '[LO] Partner with industry experts who understand the nuances of the KSA market. Let\'s discuss your project specifications.',
        cta1: '[LO] Request Detailed Quote',
        cta2: '[LO] Consult an Expert'
      }
    },
    // Service Page (Products & Categories)
    servicePage: {
      hero: {
        badge: 'كتالوجنا',
        titleLine1: 'شامل',
        titleEmphasis: 'حلول صناعية',
        subtitle:
          'توريد مجموعة واسعة من المواد الميكانيكية والكهربائية والأنابيب عبر المملكة بمعايير جودة لا هوادة فيها.',
        bgImage: ''
      },
      catalogNav: {
        title: 'كتالوج المنتجات',
        catalogPdf: '/uploads/AMHBM_Profile.pdf',
        items: {
          pipes: 'أنابيب',
          valves: 'صمامات',
          fire: 'أنظمة مكافحة الحرائق',
          hardware: 'مواد الأجهزة',
          chemicals: 'مذيبات وكيماويات',
          tools: 'أدوات البناء والصناعة',
          instrumentation: 'أجهزة القياس والوصلات',
          electrical: 'كهرباء صناعية',
          telecom: 'اتصالات صناعية',
          building: 'مواد بناء'
        }
      },
      overview: {
        title: 'نظرة عامة على الكتالوج الصناعي',
        description:
          'استكشف مجموعتنا الشاملة من المواد الصناعية عالية الأداء، والمصممة لتلبية المعايير الصارمة للبنية التحتية في المملكة العربية السعودية.'
      },
      sidebar: {
        title: 'تحسين البحث',
        materialType: {
          title: 'نوع المادة',
          options: ['الكربون الصلب', 'الفولاذ المقاوم للصدأ', 'سبائك الصلب', 'دوبلكس وسوبر دوبلكس']
        },
        standards: {
          title: 'المعايير الصناعية',
          options: ['ASME / ANSI', 'معايير ASTM', 'مواصفات API', 'DIN / EN']
        },
        help: {
          text: 'هل تحتاج إلى مواصفات معينة غير مدرجة؟ اتصل بفريق المشتريات لدينا.',
          link: 'إرسال استفسار فني'
        }
      },
      categories: {
        pipes: {
          title: 'الأنابيب والمواسير',
          image: '/uploads/1770008129-CS_pipes.webp',
          description: 'مخزون كامل من أنابيب الكربون الصلب والفولاذ المقاوم للصدأ والحديد المطاوع. مصممة لتطبيقات درجات الحرارة والضغط العالية في البنية التحتية للنفط والغاز والمياه.',
          items: [
            {
              name: 'أنابيب الكربون الصلب',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                standard: 'ASME, ASTM, BS and DIN',
                material: [
                  'أنابيب الكربون الصلب والسبائك (غير ملحومة)',
                  'أنابيب الكربون الصلب ERW (نوع ملحوم)',
                  'أنابيب الكربون الصلب (لحام القوس المغمور)'
                ],
                sizes: 'من ½ بوصة إلى 80 بوصة',
                schedule: '20/30/40/60/80/120/XXS/STD و XS',
                grade: [
                  'A53 Gr.B, A106 Gr.B, APL5L Gr.B X42, X52 & A333-6',
                  'A53-A, A53-b and APL 5L Gr.B',
                  'API 5L Gr.B, X52 and X60'
                ],
                length: '6، 12 متر، DRL، SRL7'
              },
              footerNote: 'نقدم مقاسات ودرجات خاصة عند الطلب'
            },
            {
              name: 'أنابيب الستانلس ستيل',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                standard: 'ASME, ASTM, BS and DIN',
                material: [
                  'ستانلس ستيل (غير ملحوم)، ستانلس ستيل ملحوم (ERW/EFW)'
                ],
                sizes: '1/8 بوصة إلى 12 بوصة',
                schedule: '10/20/40/80/120/XXS//SX/STD',
                grade: [
                  'A312-304/304L, 316/316L',
                  'A312-304/304L, 316/326L A358'
                ],
                length: '6، 12 متر، DRL، SRL7'
              },
              footerNote: 'نقدم مقاسات ودرجات خاصة عند الطلب'
            },
            {
              name: 'أنابيب PVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                material: 'PVC',
                thickness: 'قياسي SCH 40 / SCH 80',
                color: 'رمادي',
                sizes: '½" إلى 12"'
              }
            },
            {
              name: 'أنابيب UPVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                material: 'UPVC',
                standards: 'ASTM D1785',
                sizes: '½" إلى 12"'
              }
            },
            {
              name: 'أنابيب CPVC',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                material: 'CPVC',
                thickness: 'SCH 80',
                application: 'المياه الساخنة والباردة'
              }
            },
            {
              name: 'أنابيب HDPE',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                material: 'بولي إيثيلين عالي الكثافة (HDPE)',
                rating: 'PN10, PN16, PN20, PN25',
                sizes: '20 مم إلى 1200 مم'
              }
            },
            {
              name: 'أنابيب PPR',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                standard: 'DIN 8077/8078',
                brands: ['NIBCO', 'GULF PLAS', 'REDI', 'FIP', 'IPEX', 'NEPROPLAST']
              }
            },
            {
              name: 'أنابيب الحديد المجلفن (GI)',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA1cXlMlrPUAnbuuFnOwj6rEA6QWbshqHlClZUpg4FWK3MQswqjqljCF3bepvIjK2RnrnPHN-RPz4fgD-Q66RZC3eWK9nWfxRQwrWJOnfIQHwDeh4KHOIfmsUv4Mvlap2v2WSfTgf_8laHxTYIrWB0qy6b-K3_6TfjptLNdXfjmmk0GHOzlIqo2NmZ3mI1KMV5NE3zCFr7jGIWFy0rx9oOBOxIqEpUeOh-4b1fh7ThLTTigYCEhr8jegNVsW6IT4DCPe0jpdEwDvA'
              ],
              specs: {
                material: 'حديد مجلفن',
                standard: 'BS 1387 Class A, B, C',
                sizes: '½" إلى 6"'
              }
            }
          ]
        },
        valves: {
          title: 'الصمامات الصناعية',
          image: '/uploads/1770009030-GateValves.webp',
          description: 'حلول التحكم في التدفق عالية التكامل بما في ذلك صمامات البوابة والكرة والفراشة وعدم الرجوع. متوفرة بالفولاذ المزور والمصبوب مع أنظمة تشغيل يدوية أو آلية.',
          items: [
            {
              name: 'صمامات البوابة والكرة الأرضية وعدم الرجوع',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                types: ['صمامات البوابة', 'صمامات الكرة الأرضية (Globe)', 'صمامات عدم الرجوع', 'مصافي Y'],
                material: ['كربون صلب (WCB, LCB)', 'ستانلس ستيل (CF8, CF8M)', 'فولاذ مزور (A105, LF2, F304, F316)'],
                pressure: 'فئة 150، 300، 600، 900، 1500، 2500',
                size: '½ بوصة إلى 48 بوصة',
                standards: 'API 600, API 602, ASME B16.34'
              },
              footerNote: 'صمامات متوافقة مع NACE MR0175 متوفرة عند الطلب'
            },
            {
              name: 'صمامات الكرة والفراشة',
              type: 'detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuA8CfLvSVZ6LYCqryjnsJFCVgdkBwKnUEQy-bwPJfC3R6cer1H7zZ_2UifKMpaRQS5FORidmBxEaWqUAghs6jY9a4_bPEdT2-3gQECPt4L9MI--4LxvfEXIrN7_feOYFV4Q8Vaucc59IZckmrw_tzPKtLV08DhX6HsQ6VJ2LYrRvYptHk56TAcF7K2fzwu8-hxBy5-S8furmanBMj4zsFfM3pQRG7V2IRfbyUtAm2f9lq9Yx3PEAdLZTDCn7V0ez1EIFqgAsr4V8g'
              ],
              specs: {
                types: ['كرة عائمة', 'محمولة على مرتكز الدوران (Trunnion)', 'فراشة مزدوجة/ثلاثية الإزاحة'],
                material: ['كربون صلب', 'ستانلس ستيل', 'دوبلكس', 'سبيكة 20'],
                operation: ['تشغيل بالرافعة', 'تشغيل بالتروس', 'مشغل هوائي/كهربائي'],
                size: '2 بوصة إلى 60 بوصة',
                standards: 'API 6D, API 608'
              }
            }
          ]
        },
        fire: {
          title: 'أنظمة مكافحة الحرائق',
          image: '/uploads/1770009990-FireFightings.jpg',
          description: 'حلول سلامة شاملة بما في ذلك صنابير الإطفاء وأنظمة الرش ولوحات الكشف عن الحرائق. متوافقة تمامًا مع معايير الدفاع المدني ولوائح NFPA.',
          items: [
            {
              name: 'أنظمة الرش',
              type: 'detailed',
              images: [
                 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
                 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
              ],
              specs: {
                types: ['متدلي', 'قائم', 'جداري', 'مخفي'],
                response: ['استجابة قياسية', 'استجابة سريعة'],
                finish: ['نحاس', 'كروم', 'بوليستر أبيض'],
                approvals: ['مدرج في UL', 'معتمد من FM', 'معتمد من الدفاع المدني']
              }
            },
            {
              name: 'الصمامات وصنابير الإطفاء',
              type: 'detailed',
              images: [
                 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
                 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
              ],
              specs: {
                items: ['صمامات بوابة OS&Y', 'صمامات عدم الرجوع', 'صنابير إطفاء ذات أسطوانة رطبة', 'صنابير إطفاء ذات أسطوانة جافة'],
                pressure: 'مصنفة حتى 300 PSI',
                connection: 'شفة / محزز / مسنن',
                standard: 'NFPA, UL/FM'
              }
            },
            {
              name: 'تجهيزات محززة',
              type: 'detailed',
              images: [
                 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg',
                 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
              ],
              specs: {
                material: 'حديد مطاوع ASTM A536',
                items: ['وصلات', 'أكواع', 'تيهات', 'نقاصات', 'أغطية'],
                sizes: '1 بوصة إلى 12 بوصة',
                finish: 'مطلي بالأحمر / مجلفن'
              }
            }
          ]
        },
        hardware: {
          title: '[LO] Hardware Materials',
          image: '/uploads/workers.webp',
          description: '[LO] Complete hardware support including fasteners, gaskets, sanitary ware, and engineered drain systems for industrial and building applications.',
          items: [
            {
              name: '[LO] FASTENERS & STUDS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] Stud Bolts', '[LO] Hex Bolts', '[LO] Anchor Bolts', '[LO] Washers', '[LO] Nuts'],
                grades: ['[LO] A193 B7/B7M', '[LO] A193 B8/B8M', '[LO] A325', '[LO] Grade 8.8/10.9'],
                coatings: ['[LO] Zinc Plated', '[LO] Hot Dip Galvanized', '[LO] Cadmium', '[LO] Xylan/PTFE', '[LO] Black Phosphate']
              }
            },
            {
              name: '[LO] GASKETS & SEALING',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] Spiral Wound Gaskets', '[LO] Ring Joint Gaskets (RTJ)', '[LO] Non-Asbestos Sheets', '[LO] Flange Insulation Kits'],
                materials: ['[LO] SS304/316', '[LO] Monel', '[LO] Soft Iron', '[LO] Graphite', '[LO] PTFE', '[LO] Rubber']
              }
            },
            {
              name: '[LO] DRAINAGE SYSTEMS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                products: ['[LO] Floor Drains', '[LO] Roof Drains', '[LO] Cleanouts', '[LO] Trench Drains', '[LO] Interceptors', '[LO] Carriers'],
                material: ['[LO] Cast Iron', '[LO] Stainless Steel', '[LO] Nickel Bronze', '[LO] PVC/HDPE'],
                application: ['[LO] Industrial Floors', '[LO] Commercial Buildings', '[LO] Food Processing'],
                brands: ['[LO] MIFAB', '[LO] ZURN', '[LO] WADE']
              }
            }
          ]
        },
        chemicals: {
          title: '[LO] Solvents & Chemicals',
          image: '/uploads/1770014336-Solvent&Chemicals.webp',
          description: '[LO] Specialized cements, coatings, and chemical solutions to protect, bond, and refurbish critical infrastructure and flooring systems.',
          items: [
            {
              name: '[LO] SOLVENT CEMENTS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] PVC Cement (Grey/Clear)', '[LO] CPVC Cement (Orange)', '[LO] UPVC Cement', '[LO] Primer/Cleaner'],
                application: ['[LO] Pressure Piping', '[LO] Drainage Systems', '[LO] Conduit'],
                standards: ['[LO] ASTM D2564', '[LO] ASTM F493'],
                brands: ['[LO] EZ WELD', '[LO] WELD-ON', '[LO] OATEY', '[LO] TANGIT']
              }
            },
            {
              name: '[LO] CONSTRUCTION CHEMICALS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                solutions: ['[LO] Concrete Repair Mortars', '[LO] Epoxy Flooring', '[LO] Waterproofing Membranes', '[LO] Joint Sealants', '[LO] Grouts'],
                brands: ['[LO] Sika', '[LO] Fosroc', '[LO] BASF', '[LO] Jotun'],
                usage: ['[LO] Industrial Flooring', '[LO] Structural Repair', '[LO] Leak Prevention']
              }
            }
          ]
        },
        tools: {
          title: '[LO] Tools for Construction & Industry',
          image: '/uploads/workers.webp',
          description: '[LO] Professional-grade hand tools, power tools, and industrial specialty tools engineered for demanding construction and maintenance environments.',
          items: [
            {
              name: '[LO] HAND TOOLS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                categories: ['[LO] Measuring & Layout', '[LO] Cutting Tools', '[LO] Fastening Tools', '[LO] Striking Tools'],
                items: ['[LO] Calipers', '[LO] Wrenches', '[LO] Hammers', '[LO] Screwdrivers', '[LO] Pliers'],
                quality: '[LO] Chrome Vanadium Steel, Drop Forged'
              }
            },
            {
              name: '[LO] POWER TOOLS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] Drills & Drivers', '[LO] Grinders & Saws', '[LO] Rotary Hammers', '[LO] Demolition Breakers'],
                power: ['[LO] Cordless 18V/40V', '[LO] Corded 110V/220V'],
                brands: ['[LO] Major Industrial Brands Supported']
              }
            },
            {
              name: '[LO] INDUSTRIAL SPECIALTY',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] Pneumatic Impact Wrenches', '[LO] Pipe Threading Machines', '[LO] Hydraulic Crimpers', '[LO] Cable Cutters'],
                application: ['[LO] Heavy Industry', '[LO] Pipe Fitting', '[LO] Electrical Installation']
              }
            }
          ]
        },
        instrumentation: {
          title: '[LO] Instrumentation',
          image: '/uploads/1770011999-InstrumentationAccessoriesBgImage.jpg',
          description: '[LO] Precision accessories and fittings that ensure reliable measurement, control, and connectivity in critical instrumentation loops.',
          items: [
            {
              name: '[LO] PRESSURE GAUGES',
              type: '[LO] detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                types: ['[LO] Bourdon Tube', '[LO] Diaphragm Seal', '[LO] Differential Pressure'],
                dialSize: ['[LO] 63mm', '[LO] 100mm', '[LO] 150mm'],
                material: ['[LO] Stainless Steel 316L', '[LO] Brass', '[LO] Monel'],
                accuracy: ['[LO] ±1.0%', '[LO] ±1.6%', '[LO] ±0.5%']
              }
            },
            {
              name: '[LO] TUBING & TUBE FITTINGS',
              type: '[LO] detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                types: ['[LO] Compression Fittings', '[LO] Face Seal Fittings', '[LO] Seamless Tubing'],
                material: ['[LO] SS316/316L', '[LO] Duplex', '[LO] Inconel', '[LO] Hastelloy'],
                pressure: ['[LO] Up to 6000 PSI', '[LO] Up to 10000 PSI'],
                standards: ['[LO] ASTM A269', '[LO] ASTM A213']
              }
            },
            {
              name: '[LO] NEEDLE & MANIFOLD VALVES',
              type: '[LO] detailed',
              images: [
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z',
                'https://lh3.googleusercontent.com/aida-public/AB6AXuB0e8b1F4nNn8t1h5iJp9qX0y7s1l0G2K6n3d7f4j9h5a2b0c1d8e3f6g4h7i5j2k8l1m9n0o1p2q3r4s5t6u7v8w9x0y1z2a3b4c5d6e7f8g9h0i1j2k3l4m5n6o7p8q9r0s1t2u3v4w5x6y7z'
              ],
              specs: {
                types: ['[LO] 2-Way', '[LO] 3-Way', '[LO] 5-Way Manifolds', '[LO] Integral Bonnet Needle Valves'],
                connection: ['[LO] NPT', '[LO] BSP', '[LO] Compression'],
                rating: ['[LO] 6000 PSI', '[LO] 10000 PSI'],
                packing: ['[LO] PTFE', '[LO] Graphite']
              }
            }
          ]
        },
        electrical: {
          title: '[LO] Industrial Electrical',
          image: '/uploads/1770013452-IndustrialElectrical.webp',
          description: '[LO] Low, medium, and high-voltage cabling with complete termination, protection, and earthing accessories for safe power distribution.',
          items: [
            {
              name: 'كابل',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                types: ['كابل جهد منخفض', 'جهد متوسط', 'جهد عالي', 'كابل مرن']
              }
            },
            {
              name: 'عروات كابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                materials: ['نحاس', 'ألمنيوم', 'برونز', 'ثنائي المعدن']
              }
            },
            {
              name: 'روابط كابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                types: ['PVC', 'ستانلس ستيل', 'مغطى بـ PVC']
              }
            },
            {
              name: 'التجهيزات والملحقات الكهربائية',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                items: [
                    'قنوات كهربائية (EMT، صلبة، PVC/UPVC/CPVC)',
                    'حاويات مقاومة للانفجار',
                    'قواطع دوائر',
                    'صندوق كهربائي',
                    'موصلات الأسلاك',
                    'علامات الأسلاك',
                    'جلب كابلات (بلاستيك/نايلون، نحاس، ستانلس ستيل، ألمنيوم)',
                    'أنابيب الانكماش الحراري',
                    'أطقم الإنهاء والوصل'
                ]
              }
            },
            {
              name: 'حوامل وسلالم الكابلات',
              type: 'detailed',
              images: [
                '/uploads/workers.webp',
                '/uploads/workers.webp'
              ],
              specs: {
                types: ['نوع سلم', 'نوع مثقب', 'قاع صلب', 'شبكة سلكية', 'قناة']
              }
            }
          ]
        },
        telecom: {
          title: '[LO] Industrial Telecom',
          image: '/uploads/telecom.png',
          description: '[LO] Fibre optic and ducting solutions that enable robust industrial networking and communications infrastructure.',
          items: [
            {
              name: '[LO] FIBRE OPTIC SYSTEMS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                cables: ['[LO] Single Mode (OS2)', '[LO] Multi Mode (OM3/OM4)', '[LO] Armored Outdoor Cables'],
                accessories: ['[LO] Patch Cords', '[LO] Pigtails', '[LO] Splice Enclosures', '[LO] Connectors (LC/SC/ST)'],
                testing: ['[LO] OTDR Verified', '[LO] Insertion Loss Tested']
              }
            },
            {
              name: '[LO] DUCTING SOLUTIONS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                pipes: ['[LO] HDPE Silicon Core Ducts', '[LO] Micro Ducts', '[LO] PVC Ducts'],
                sealing: ['[LO] Mechanical Duct Plugs', '[LO] Inflatable Duct Seals', '[LO] Heat Shrink End Caps'],
                features: ['[LO] Low Friction', '[LO] High Crush Resistance', '[LO] UV Stabilized']
              }
            },
            {
              name: '[LO] NETWORK INFRASTRUCTURE',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                cabinets: ['[LO] 19" Data Cabinets', '[LO] Server Racks', '[LO] Outdoor Street Cabinets'],
                copper: ['[LO] Cat6/Cat6A Cables', '[LO] Patch Panels', '[LO] Keystone Jacks'],
                active: ['[LO] Industrial Switches', '[LO] Media Converters']
              }
            }
          ]
        },
        building: {
          title: '[LO] Building Materials',
          image: '/uploads/workers.webp',
          description: '[LO] Fundamental construction materials including wood, steel, insulation, and cement products for structural and architectural applications.',
          items: [
            {
              name: '[LO] LUMBER & WOOD PRODUCTS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] Softwood (Pine, Spruce)', '[LO] Hardwood (Oak, Maple)', '[LO] Plywood & OSB'],
                grades: ['[LO] Construction Grade', '[LO] Furniture Grade', '[LO] Marine Grade'],
                applications: ['[LO] Structural Framing', '[LO] Formwork', '[LO] Interior Finishing']
              }
            },
            {
              name: '[LO] INSULATION MATERIALS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                types: ['[LO] Fiberglass Batts', '[LO] Rockwool Slabs', '[LO] XPS/EPS Boards'],
                properties: ['[LO] Thermal Resistance (R-Value)', '[LO] Acoustic Dampening', '[LO] Fire Resistance'],
                forms: ['[LO] Rolls', '[LO] Rigid Boards', '[LO] Loose Fill']
              }
            },
            {
              name: '[LO] STEEL PRODUCTS',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                structural: ['[LO] I-Beams (IPE, HEA, HEB)', '[LO] Channels (UPN)', '[LO] Angles'],
                reinforcement: ['[LO] Rebar (Deformed Bars)', '[LO] Wire Mesh', '[LO] Tying Wire'],
                standards: ['[LO] ASTM A36', '[LO] BS 4449', '[LO] DIN 488']
              }
            },
            {
              name: '[LO] GYPSUM & ACCESSORIES',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                boards: ['[LO] Regular', '[LO] Moisture Resistant (Green)', '[LO] Fire Rated (Pink)'],
                profiles: ['[LO] Studs', '[LO] Tracks', '[LO] Furring Channels'],
                accessories: ['[LO] Joint Compound', '[LO] Fiber Tape', '[LO] Corner Beads']
              }
            },
            {
              name: '[LO] CEMENT & AGGREGATES',
              type: '[LO] detailed',
              images: [
                 '/uploads/workers.webp',
                 '/uploads/workers.webp'
              ],
              specs: {
                cement: ['[LO] OPC (Type I)', '[LO] SRC (Type V)', '[LO] White Cement'],
                aggregates: ['[LO] Fine Sand', '[LO] Coarse Sand', '[LO] Crushed Stone (3/4", 3/8")'],
                additives: ['[LO] Plasticizers', '[LO] Waterproofers', '[LO] Bonding Agents']
              }
            }
          ]
        }
      },
      badges: {
        aramcoApproved: '[LO] Aramco Approved',
        sabicReady: '[LO] SABIC Ready',
        api6d: '[LO] API 6D Certified',
        ulListed: '[LO] UL Listed',
        fmApproved: '[LO] FM Approved'
      },
      viewRange: '[LO] View Full Range',
      cta: '[LO] Explore More Categories'
    },
    // About Page
    aboutPage: {
      hero: {
        bgImage: '/uploads/industry.png',
        badge: '[LO] Established Excellence',
        titleLine1: '[LO] Who We',
        titleEmphasis: '[LO] Are.',
        subtitle: '[LO] AMHBM stands as a pillar of Saudi Arabia\'s industrial supply chain, providing the essential materials that build the future of the Kingdom.'
      },
      pillars: {
        integrity: {
          label: '[LO] Our Pillar',
          title: '[LO] Unwavering Integrity'
        },
        quality: {
          label: '[LO] Our Standard',
          title: '[LO] Engineering Quality'
        },
        commitment: {
          label: '[LO] Our Promise',
          title: '[LO] True Commitment'
        }
      },
      visionMission: {
        vision: {
          title: '[LO] The Vision',
          text: '[LO] To be the foremost strategic partner in the Middle East’s industrial evolution, recognized for setting the gold standard in procurement, technical expertise, and reliability. We envision a future where AMHBM is synonymous with the structural integrity of Saudi Arabia\'s most ambitious projects.'
        },
        mission: {
          title: '[LO] The Mission',
          text: '[LO] Our mission is to empower the Kingdom\'s industrial sectors by providing high-specification building materials through a seamless, globally-integrated supply chain. We are dedicated to ensuring safety, efficiency, and sustainability in every component we deliver to our partners.'
        }
      },
      quote: {
        image: '/uploads/workers.webp',
        imageOverlayTitle: '[LO] Leadership Team',
        imageOverlaySubtitle: '[LO] Executive Office',
        text1: '[LO] We are not just suppliers; we are the foundation of',
        textEmphasis: '[LO] Saudi Vision 2030.',
        desc1: '[LO] At AMHBM, we recognize that our role transcends simple trade. As Saudi Arabia undergoes a historic transformation, the materials we provide form the physical backbone of our nation\'s progress.',
        desc2: '[LO] Our commitment to quality is personal. Every valve, every pipe, and every electrical component we source is scrutinized to ensure it meets the rigorous demands of the Kingdom\'s future infrastructure. Together, we are building a legacy of excellence.',
        role: '[LO] CEO & Managing Director',
        company: '[LO] Amal Mohammed Harthi for Building Materials'
      },
      advantage: {
        label: '[LO] Strategic Advantage',
        title: '[LO] Why Partners Choose AMHBM',
        global: {
          title: '[LO] Global Partnerships',
          text: '[LO] Direct access to Tier-1 manufacturers across Europe, Asia, and the Americas, ensuring authentic, high-performance materials.'
        },
        logistics: {
          title: '[LO] Logistical Excellence',
          text: '[LO] A robust distribution network across Saudi Arabia that guarantees on-time delivery even to the most remote project sites.'
        },
        technical: {
          title: '[LO] Technical Expertise',
          text: '[LO] Our team of specialists provides deep technical consultation to ensure materials perfectly match engineering specifications.'
        }
      },
      vision2030: {
        logo: SaudiVisionLogo,
        label: '[LO] National Alignment',
        titleLine1: '[LO] Committed to',
        titleEmphasis: '[LO] Saudi Vision 2030',
        text: '[LO] As Saudi Arabia builds for the future, AMHBM provides the critical industrial components that power the Kingdom\'s infrastructure. From giga-projects to industrial cities, our supply chain is the backbone of the nation\'[LO] s transformative growth and economic diversification goals.',
        link: '[LO] Learn about our impact'
      }
    },
    // Career Page (Existing)
    careerPage: {
      hero: {
        image: '/uploads/industry.png',
        badge: '[LO] CAREER OPPORTUNITIES',
        titleLine1: '[LO] Build the Future of',
        titleEmphasis: '[LO] Saudi Industry',
        titleLine2: '[LO] with Us',
        subtitle:
          '[LO] Join a team of experts dedicated to excellence in industrial supply chain and infrastructure. Empowering the Kingdom\'s growth through innovation and integrity.',
        cta: '[LO] Explore Openings'
      },
      culture: {
        badge: '[LO] Life at AMHBM',
        title: '[LO] Culture that Drives Progress.',
        description:
          '[LO] Our culture is built on innovation, integrity, and a deep alignment with Saudi Vision 2030. We foster an environment where professional growth meets national impact.',
        cards: {
          collaboration: {
            image: '/uploads/workers.webp',
            title: '[LO] Team Collaboration',
            text: '[LO] Fostering a spirit of shared success in every project.'
          },
          workshops: {
            image: '/uploads/statigic partner.png',
            title: '[LO] Workshops',
            text: '[LO] Continuous learning and professional skill enhancement.'
          },
          impact: {
            image: '/uploads/industry.png',
            title: '[LO] Impact on Site',
            text: '[LO] Witnessing the tangible results of our industrial supply.'
          },
          vision: {
            image: '/uploads/workers.webp',
            title: '[LO] Vision 2030',
            text: '[LO] Dedicated to the Kingdom\'s industrial transformation.'
          }
        }
      },
      benefits: {
        items: {
          compensation: {
            title: '[LO] Competitive Compensation',
            text: '[LO] Rewarding excellence with industry-leading packages and benefits.'
          },
          growth: {
            title: '[LO] Professional Growth',
            text: '[LO] Clear career pathways and support for advanced certifications.'
          },
          impact: {
            title: '[LO] Saudi-focused Impact',
            text: '[LO] Directly contribute to the Kingdom\'s infrastructure and giga-projects.'
          },
          culture: {
            title: '[LO] Inclusive Culture',
            text: '[LO] A diverse workplace where every voice is valued and heard.'
          }
        }
      },
      applicationForm: {
        firstName: '[LO] First Name',
        firstNamePlaceholder: '[LO] Enter your first name here',
        lastName: '[LO] Last Name',
        lastNamePlaceholder: '[LO] Last Name',
        dateOfBirth: '[LO] Date of Birth',
        dateOfBirthPlaceholder: '[LO] MM-DD-YYY',
        phoneNumber: '[LO] Phone Number',
        phoneNumberPlaceholder: '[LO] Example: +966-5xxxxxxx',
        gender: '[LO] Gender',
        genderOptions: {
          male: '[LO] Male',
          female: '[LO] Female',
          preferNotToSay: '[LO] Prefer Not To Say'
        },
        email: '[LO] Email Address',
        emailPlaceholder: '[LO] Email',
        fileUpload: '[LO] File Upload',
        fileUploadButton: '[LO] Choose File',
        fileUploadPlaceholder: '[LO] No file chosen'
      },

      cta: {
        title: '[LO] Don\'t see a fit?',
        text: '[LO] Send us your CV for future opportunities. We are always looking for exceptional talent to join our industrial mission.',
        button: '[LO] Upload Resume'
      }
    },
    // Contact Page (Existing)
    contactPage: {
      hero: {
        image: '/uploads/industry.png',
        badge: '[LO] Get In Touch',
        titleLine1: '[LO] Contact Our',
        titleEmphasis: '[LO] Industrial Experts',
        subtitle:
          '[LO] From material procurement to project support, we are here to assist your industrial mission in the Kingdom.'
      },
      cards: {
        visitTitle: '[LO] Visit Us',
        visitLine1: '[LO] Riyadh Headquarters',
        visitLine2: '[LO] Al-Malaz District, King Abdulaziz Road',
        visitLine3: '[LO] Riyadh, Kingdom of Saudi Arabia',
        callTitle: '[LO] Call Us',
        callMainLabel: '[LO] Main Office:',
        callSalesLabel: '[LO] Sales Dept:',
        callMainNumber: '+966 11 123 4567',
        callSalesNumber: '+966 55 987 6543',
        emailTitle: '[LO] Email Us',
        emailGeneralLabel: '[LO] General:',
        emailSalesLabel: '[LO] Sales Support:'
      },
      form: {
        title: '[LO] Send an Inquiry',
        fullName: '[LO] Full Name',
        companyName: '[LO] Company Name',
        industry: '[LO] Industry Sector',
        message: '[LO] Message',
        submit: '[LO] Submit Inquiry',
        fullNamePlaceholder: '',
        companyNamePlaceholder: '',
        messagePlaceholder: '',
        industryOptions: {
          oilGas: '[LO] Oil & Gas',
          infrastructure: '[LO] Infrastructure & Construction',
          mining: '[LO] Mining & Metallurgy',
          manufacturing: '[LO] Manufacturing',
          other: '[LO] Other'
        }
      },
      sidebar: {
        businessHoursTitle: '[LO] Business Hours',
        sundayThursday: '[LO] Sunday - Thursday:',
        friday: '[LO] Friday:',
        saturday: '[LO] Saturday:',
        closed: '[LO] Closed',
        connectTitle: '[LO] Connect With Us',
        certifiedTitle: '[LO] Certified Excellence'
      },



      toast: {
        success: '[LO] Thank you for your inquiry. We will contact you soon.'
      }
    },
    // Footer
    footer: {
      description: '[LO] Leading industrial materials trading partner in Saudi Arabia, dedicated to providing high-specification solutions for the Kingdom\'s growth.',
      navigation: '[LO] Navigation',
      industries: '[LO] Catalog',
      contact: '[LO] Contact',
      navLinks: {
        home: '[LO] Home',
        about: '[LO] Who We Are',
        service: '[LO] Our Solutions',
        career: '[LO] Career',
        contact: '[LO] Quality Compliance'
      },
      industryLinks: {
        oil: '[LO] Pipes & Piping',
        petro: '[LO] Valves & Fittings',
        power: '[LO] Instrumentation',
        infrastructure: '[LO] Structural Steel'
      },
      contactInfo: {
        location: '[LO] Kingdom of Saudi Arabia Headquarters',
        email: '[LO] info@amhbm.com',
        phone: '[LO] +966550473526'
      },
      copyright: '[LO] © 2024 Amal Mohammed Harthi for Building Materials. All rights reserved.'
    }
  }
};
